/* tslint:disable */
/* eslint-disable */
/**
 * search-track - API文档
 * <b>注意：仅开启swagger选项有效，建议上线前关闭该选项</b>  search-track project scaffold
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const BASEMENUTYPEE = {
    Link: 'link',
    Dir: 'dir'
} as const;

export type BASEMENUTYPEE = typeof BASEMENUTYPEE[keyof typeof BASEMENUTYPEE];


/**
 * 
 * @export
 * @enum {string}
 */

export const BASEROUTETYPEE = {
    AdminPage: 'admin_page',
    CommonPage: 'common_page'
} as const;

export type BASEROUTETYPEE = typeof BASEROUTETYPEE[keyof typeof BASEROUTETYPEE];


/**
 * 
 * @export
 * @interface BaseApiAdminVo
 */
export interface BaseApiAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseApiAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'swaggerPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'method'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'tagName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'summary'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseApiAdminVo
     */
    'allowAll': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseApiAdminVo
     */
    'enable': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseApiAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof BaseApiAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BaseDictionaryAdminVo
 */
export interface BaseDictionaryAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseDictionaryAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseDictionaryAdminVo
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof BaseDictionaryAdminVo
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof BaseDictionaryAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BaseMenuAdminVo
 */
export interface BaseMenuAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseMenuAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'url'?: string;
    /**
     * 
     * @type {BASEMENUTYPEE}
     * @memberof BaseMenuAdminVo
     */
    'type': BASEMENUTYPEE;
    /**
     * 
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'icon'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseMenuAdminVo
     */
    'sequence': number;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMenuAdminVo
     */
    'enable': boolean;
    /**
     * 
     * @type {number}
     * @memberof BaseMenuAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseMenuAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseMenuAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseMenuAdminVo
     */
    'routeIds'?: Array<number>;
}


/**
 * 
 * @export
 * @interface BaseMessageAdminVo
 */
export interface BaseMessageAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseMessageAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseMessageAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseMessageAdminVo
     */
    'sendUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseMessageAdminVo
     */
    'msgType': string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessageAdminVo
     */
    'msgSummary'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessageAdminVo
     */
    'msgContent': string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessageAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseMessageAdminVo
     */
    'targetUserIds'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseMessageAdminVo
     */
    'targetOrgCodes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BaseMessagePrivateSendVo
 */
export interface BaseMessagePrivateSendVo {
    /**
     * 
     * @type {number}
     * @memberof BaseMessagePrivateSendVo
     */
    'targetUserId': number;
    /**
     * 
     * @type {string}
     * @memberof BaseMessagePrivateSendVo
     */
    'msgSummary'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessagePrivateSendVo
     */
    'msgContent': string;
}
/**
 * 
 * @export
 * @interface BaseMessagePrivateUserSearchVo
 */
export interface BaseMessagePrivateUserSearchVo {
    /**
     * 
     * @type {string}
     * @memberof BaseMessagePrivateUserSearchVo
     */
    'keyword'?: string;
}
/**
 * 
 * @export
 * @interface BaseOperateAdminVo
 */
export interface BaseOperateAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseOperateAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseOperateAdminVo
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof BaseOperateAdminVo
     */
    'name': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseOperateAdminVo
     */
    'roleIds': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof BaseOperateAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BaseOrderByVo
 */
export interface BaseOrderByVo {
    /**
     * 
     * @type {string}
     * @memberof BaseOrderByVo
     */
    'field': string;
    /**
     * 
     * @type {any}
     * @memberof BaseOrderByVo
     */
    'direction': any;
}
/**
 * 
 * @export
 * @interface BaseOrganizationAdminVo
 */
export interface BaseOrganizationAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseOrganizationAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseOrganizationAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseOrganizationAdminVo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseOrganizationAdminVo
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof BaseOrganizationAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseOrganizationAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BasePageQueryVo
 */
export interface BasePageQueryVo {
    /**
     * 
     * @type {number}
     * @memberof BasePageQueryVo
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof BasePageQueryVo
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface BaseResultVo
 */
export interface BaseResultVo {
    /**
     * 
     * @type {boolean}
     * @memberof BaseResultVo
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseResultVo
     */
    'msg'?: string;
    /**
     * 
     * @type {any}
     * @memberof BaseResultVo
     */
    'data'?: any;
}
/**
 * 
 * @export
 * @interface BaseRoleAdminVo
 */
export interface BaseRoleAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseRoleAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'orgCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseRoleAdminVo
     */
    'level'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseRoleAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BaseRouteAdminVo
 */
export interface BaseRouteAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseRouteAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {BASEROUTETYPEE}
     * @memberof BaseRouteAdminVo
     */
    'type': BASEROUTETYPEE;
    /**
     * 
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'allowAll': boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'componentName': string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'isNest': boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'redirect'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'enable': boolean;
    /**
     * 
     * @type {number}
     * @memberof BaseRouteAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseRouteAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseRouteAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BaseRouteAdminVo
     */
    'isIndex'?: boolean;
}


/**
 * 
 * @export
 * @interface BaseTenantAdminVo
 */
export interface BaseTenantAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseTenantAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseTenantAdminVo
     */
    'name': string;
    /**
     * 
     * @type {any}
     * @memberof BaseTenantAdminVo
     */
    'meta'?: any;
    /**
     * 
     * @type {string}
     * @memberof BaseTenantAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface BaseUserAdminVo
 */
export interface BaseUserAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseUserAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseUserAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<BaseUserMetaItem>}
     * @memberof BaseUserAdminVo
     */
    'meta'?: Array<BaseUserMetaItem>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseUserAdminVo
     */
    'roleIds': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseUserAdminVo
     */
    'orgCodes'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseUserAdminVo
     */
    'routeIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseUserAdminVo
     */
    'menuIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface BaseUserMetaItem
 */
export interface BaseUserMetaItem {
    /**
     * 
     * @type {string}
     * @memberof BaseUserMetaItem
     */
    '_key': string;
    /**
     * 
     * @type {any}
     * @memberof BaseUserMetaItem
     */
    '_value': any;
    /**
     * 
     * @type {string}
     * @memberof BaseUserMetaItem
     */
    '_label': string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserMetaItem
     */
    '_type': string;
    /**
     * 
     * @type {string}
     * @memberof BaseUserMetaItem
     */
    '_icon'?: string;
}
/**
 * 
 * @export
 * @interface BaseUserRoleAdminVo
 */
export interface BaseUserRoleAdminVo {
    /**
     * 
     * @type {number}
     * @memberof BaseUserRoleAdminVo
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof BaseUserRoleAdminVo
     */
    'orgCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseUserRoleAdminVo
     */
    'roleId': number;
}
/**
 * 
 * @export
 * @interface PartialBaseApiAdminVo
 */
export interface PartialBaseApiAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseApiAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'swaggerPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'method'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'tagName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'summary'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseApiAdminVo
     */
    'allowAll'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseApiAdminVo
     */
    'enable'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseApiAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseApiAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseBalanceRecordAdminVo
 */
export interface PartialBaseBalanceRecordAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'balanceBefore'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'balanceAfter'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'refId'?: string;
    /**
     * 
     * @type {any}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'extra'?: any;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseBalanceRecordAdminVo
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseDictionaryAdminVo
 */
export interface PartialBaseDictionaryAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseDictionaryAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseLogAdminVo
 */
export interface PartialBaseLogAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseLogAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseLogAdminVo
     */
    'end'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseLogAdminVo
     */
    'startId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseLogAdminVo
     */
    'endId'?: number;
}
/**
 * 
 * @export
 * @interface PartialBaseMenuAdminVo
 */
export interface PartialBaseMenuAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMenuAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'url'?: string;
    /**
     * 
     * @type {BASEMENUTYPEE}
     * @memberof PartialBaseMenuAdminVo
     */
    'type'?: BASEMENUTYPEE;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'icon'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMenuAdminVo
     */
    'sequence'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseMenuAdminVo
     */
    'enable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMenuAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMenuAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseMenuAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseMenuAdminVo
     */
    'routeIds'?: Array<number>;
}


/**
 * 
 * @export
 * @interface PartialBaseMessageAdminVo
 */
export interface PartialBaseMessageAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMessageAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMessageAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseMessageAdminVo
     */
    'sendUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMessageAdminVo
     */
    'msgType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMessageAdminVo
     */
    'msgSummary'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMessageAdminVo
     */
    'msgContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseMessageAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseMessageAdminVo
     */
    'targetUserIds'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PartialBaseMessageAdminVo
     */
    'targetOrgCodes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PartialBaseOperateAdminVo
 */
export interface PartialBaseOperateAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseOperateAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOperateAdminVo
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOperateAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseOperateAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOperateAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseOrganizationAdminVo
 */
export interface PartialBaseOrganizationAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseOrganizationAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBasePaymentOrderAdminVo
 */
export interface PartialBasePaymentOrderAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'platform'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'orderNo'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'platformOrderNo'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'refundAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'expireAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'paidAt'?: string;
    /**
     * 
     * @type {any}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'extra'?: any;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBasePaymentOrderAdminVo
     */
    'updateTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseRoleAdminVo
 */
export interface PartialBaseRoleAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseRoleAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'orgCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseRoleAdminVo
     */
    'level'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRoleAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseRouteAdminVo
 */
export interface PartialBaseRouteAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseRouteAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {BASEROUTETYPEE}
     * @memberof PartialBaseRouteAdminVo
     */
    'type'?: BASEROUTETYPEE;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'allowAll'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'componentName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'isNest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'redirect'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'enable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseRouteAdminVo
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseRouteAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseRouteAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBaseRouteAdminVo
     */
    'isIndex'?: boolean;
}


/**
 * 
 * @export
 * @interface PartialBaseScheduleAdminVo
 */
export interface PartialBaseScheduleAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleInterval'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleCurrent'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'ruleNextTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseScheduleAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseTenantAdminVo
 */
export interface PartialBaseTenantAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseTenantAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseTenantAdminVo
     */
    'name'?: string;
    /**
     * 
     * @type {any}
     * @memberof PartialBaseTenantAdminVo
     */
    'meta'?: any;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseTenantAdminVo
     */
    'createTime'?: string;
}
/**
 * 
 * @export
 * @interface PartialBaseUserAdminVo
 */
export interface PartialBaseUserAdminVo {
    /**
     * 
     * @type {number}
     * @memberof PartialBaseUserAdminVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PartialBaseUserAdminVo
     */
    'tenantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialBaseUserAdminVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {Array<BaseUserMetaItem>}
     * @memberof PartialBaseUserAdminVo
     */
    'meta'?: Array<BaseUserMetaItem>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseUserAdminVo
     */
    'roleIds'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PartialBaseUserAdminVo
     */
    'orgCodes'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseUserAdminVo
     */
    'routeIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartialBaseUserAdminVo
     */
    'menuIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface ResultVo
 */
export interface ResultVo {
    /**
     * 
     * @type {boolean}
     * @memberof ResultVo
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultVo
     */
    'msg'?: string;
    /**
     * 
     * @type {any}
     * @memberof ResultVo
     */
    'data'?: any;
}
/**
 * 
 * @export
 * @interface SearchTrackAccountVo
 */
export interface SearchTrackAccountVo {
    /**
     * 
     * @type {number}
     * @memberof SearchTrackAccountVo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackAccountVo
     */
    'stationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackAccountVo
     */
    'ownerOpenid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackAccountVo
     */
    'platform': string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackAccountVo
     */
    'account': string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackAccountVo
     */
    'password': string;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackAccountVo
     */
    'enabled'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackAccountVo
     */
    'sessionStatus'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackAccountVo
     */
    'stationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackAccountVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackAccountVo
     */
    'updateTime'?: string;
}
/**
 * 
 * @export
 * @interface SearchTrackAgreementSaveVo
 */
export interface SearchTrackAgreementSaveVo {
    /**
     * 
     * @type {number}
     * @memberof SearchTrackAgreementSaveVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackAgreementSaveVo
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackAgreementSaveVo
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackAgreementSaveVo
     */
    'content'?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackAgreementSaveVo
     */
    'status'?: number;
}
/**
 * 
 * @export
 * @interface SearchTrackLoginVo
 */
export interface SearchTrackLoginVo {
    /**
     * 
     * @type {string}
     * @memberof SearchTrackLoginVo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackLoginVo
     */
    'openid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackLoginVo
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackLoginVo
     */
    'avatar'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchTrackLoginVo
     */
    'silent'?: boolean;
}
/**
 * 
 * @export
 * @interface SearchTrackParcelQueryVo
 */
export interface SearchTrackParcelQueryVo {
    /**
     * 
     * @type {number}
     * @memberof SearchTrackParcelQueryVo
     */
    'stationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackParcelQueryVo
     */
    'keyword'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackParcelQueryVo
     */
    'openid'?: string;
}
/**
 * 
 * @export
 * @interface SearchTrackParcelSmsSendVo
 */
export interface SearchTrackParcelSmsSendVo {
    /**
     * 
     * @type {number}
     * @memberof SearchTrackParcelSmsSendVo
     */
    'accountId': number;
}
/**
 * 
 * @export
 * @interface SearchTrackParcelSmsSubmitVo
 */
export interface SearchTrackParcelSmsSubmitVo {
    /**
     * 
     * @type {number}
     * @memberof SearchTrackParcelSmsSubmitVo
     */
    'accountId': number;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackParcelSmsSubmitVo
     */
    'smsCode': string;
}
/**
 * 
 * @export
 * @interface SearchTrackProfileUpdateVo
 */
export interface SearchTrackProfileUpdateVo {
    /**
     * 
     * @type {string}
     * @memberof SearchTrackProfileUpdateVo
     */
    'openid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackProfileUpdateVo
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackProfileUpdateVo
     */
    'avatar'?: string;
}
/**
 * 
 * @export
 * @interface SearchTrackQrcodeBatchIdsVo
 */
export interface SearchTrackQrcodeBatchIdsVo {
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchTrackQrcodeBatchIdsVo
     */
    'ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface SearchTrackQrcodeBatchVo
 */
export interface SearchTrackQrcodeBatchVo {
    /**
     * 
     * @type {number}
     * @memberof SearchTrackQrcodeBatchVo
     */
    'stationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackQrcodeBatchVo
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackQrcodeBatchVo
     */
    'remark'?: string;
}
/**
 * 
 * @export
 * @interface SearchTrackQrcodeBindSchemeVo
 */
export interface SearchTrackQrcodeBindSchemeVo {
    /**
     * 
     * @type {string}
     * @memberof SearchTrackQrcodeBindSchemeVo
     */
    'scheme': string;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackQrcodeBindSchemeVo
     */
    'stationId': number;
}
/**
 * 
 * @export
 * @interface SearchTrackQrcodeBindVo
 */
export interface SearchTrackQrcodeBindVo {
    /**
     * 
     * @type {string}
     * @memberof SearchTrackQrcodeBindVo
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackQrcodeBindVo
     */
    'stationId': number;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackQrcodeBindVo
     */
    'ownerOpenid'?: string;
}
/**
 * 
 * @export
 * @interface SearchTrackQrcodeGenerateVo
 */
export interface SearchTrackQrcodeGenerateVo {
    /**
     * 
     * @type {number}
     * @memberof SearchTrackQrcodeGenerateVo
     */
    'stationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackQrcodeGenerateVo
     */
    'ownerOpenid'?: string;
}
/**
 * 
 * @export
 * @interface SearchTrackQrcodeRefreshVo
 */
export interface SearchTrackQrcodeRefreshVo {
    /**
     * 
     * @type {number}
     * @memberof SearchTrackQrcodeRefreshVo
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface SearchTrackStationVo
 */
export interface SearchTrackStationVo {
    /**
     * 
     * @type {number}
     * @memberof SearchTrackStationVo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackStationVo
     */
    'ownerOpenid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackStationVo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackStationVo
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackStationVo
     */
    'enabled'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackStationVo
     */
    'accountCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackStationVo
     */
    'qrcodeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchTrackStationVo
     */
    'qrcodeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackStationVo
     */
    'qrcodeCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackStationVo
     */
    'qrImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackStationVo
     */
    'urlScheme'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackStationVo
     */
    'qrMode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchTrackStationVo
     */
    'nfcReady'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackStationVo
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTrackStationVo
     */
    'updateTime'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject1
 */
export interface SystemGenerateObject1 {
    /**
     * 
     * @type {PartialBaseApiAdminVo}
     * @memberof SystemGenerateObject1
     */
    'conditions'?: PartialBaseApiAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject1
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject1
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject16
 */
export interface SystemGenerateObject16 {
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemGenerateObject16
     */
    'platforms': Array<string>;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject17
 */
export interface SystemGenerateObject17 {
    /**
     * 
     * @type {PartialBaseRoleAdminVo}
     * @memberof SystemGenerateObject17
     */
    'conditions'?: PartialBaseRoleAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject17
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject17
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject18
 */
export interface SystemGenerateObject18 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject18
     */
    'userId': number;
    /**
     * 
     * @type {Array<BaseUserRoleAdminVo>}
     * @memberof SystemGenerateObject18
     */
    'userRoleVos': Array<BaseUserRoleAdminVo>;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject19
 */
export interface SystemGenerateObject19 {
    /**
     * 
     * @type {PartialBaseRoleAdminVo}
     * @memberof SystemGenerateObject19
     */
    'conditions'?: PartialBaseRoleAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject19
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject19
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject2
 */
export interface SystemGenerateObject2 {
    /**
     * 
     * @type {PartialBaseMenuAdminVo}
     * @memberof SystemGenerateObject2
     */
    'conditions'?: PartialBaseMenuAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject2
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject2
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject20
 */
export interface SystemGenerateObject20 {
    /**
     * 
     * @type {PartialBaseRoleAdminVo}
     * @memberof SystemGenerateObject20
     */
    'conditions'?: PartialBaseRoleAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject20
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject20
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject20
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject21
 */
export interface SystemGenerateObject21 {
    /**
     * 
     * @type {PartialBaseUserAdminVo}
     * @memberof SystemGenerateObject21
     */
    'conditions'?: PartialBaseUserAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject21
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject21
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject22
 */
export interface SystemGenerateObject22 {
    /**
     * 
     * @type {PartialBaseUserAdminVo}
     * @memberof SystemGenerateObject22
     */
    'conditions'?: PartialBaseUserAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject22
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject22
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject22
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject23
 */
export interface SystemGenerateObject23 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject23
     */
    'oldPw': string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject23
     */
    'newPw': string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject24
 */
export interface SystemGenerateObject24 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject24
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject24
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject24
     */
    'newPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject24
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject25
 */
export interface SystemGenerateObject25 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject25
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject25
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject25
     */
    'newEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject25
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject26
 */
export interface SystemGenerateObject26 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject26
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject26
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject26
     */
    'avatar'?: string;
    /**
     * 
     * @type {Array<BaseUserMetaItem>}
     * @memberof SystemGenerateObject26
     */
    'meta'?: Array<BaseUserMetaItem>;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject27
 */
export interface SystemGenerateObject27 {
    /**
     * 
     * @type {PartialBaseOrganizationAdminVo}
     * @memberof SystemGenerateObject27
     */
    'conditions'?: PartialBaseOrganizationAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject27
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject27
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject28
 */
export interface SystemGenerateObject28 {
    /**
     * 
     * @type {PartialBaseOrganizationAdminVo}
     * @memberof SystemGenerateObject28
     */
    'conditions'?: PartialBaseOrganizationAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject28
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject28
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject28
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject29
 */
export interface SystemGenerateObject29 {
    /**
     * 
     * @type {PartialBaseLogAdminVo}
     * @memberof SystemGenerateObject29
     */
    'conditions'?: PartialBaseLogAdminVo;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject29
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject3
 */
export interface SystemGenerateObject3 {
    /**
     * 
     * @type {PartialBaseMenuAdminVo}
     * @memberof SystemGenerateObject3
     */
    'conditions'?: PartialBaseMenuAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject3
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject3
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject3
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject30
 */
export interface SystemGenerateObject30 {
    /**
     * 
     * @type {PartialBaseLogAdminVo}
     * @memberof SystemGenerateObject30
     */
    'conditions'?: PartialBaseLogAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject30
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject30
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject31
 */
export interface SystemGenerateObject31 {
    /**
     * 
     * @type {PartialBaseLogAdminVo}
     * @memberof SystemGenerateObject31
     */
    'conditions'?: PartialBaseLogAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject31
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject31
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject31
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject32
 */
export interface SystemGenerateObject32 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject32
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject33
 */
export interface SystemGenerateObject33 {
    /**
     * 
     * @type {PartialBaseDictionaryAdminVo}
     * @memberof SystemGenerateObject33
     */
    'conditions'?: PartialBaseDictionaryAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject33
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject33
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject34
 */
export interface SystemGenerateObject34 {
    /**
     * 
     * @type {PartialBaseDictionaryAdminVo}
     * @memberof SystemGenerateObject34
     */
    'conditions'?: PartialBaseDictionaryAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject34
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject34
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject34
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject35
 */
export interface SystemGenerateObject35 {
    /**
     * 
     * @type {PartialBaseTenantAdminVo}
     * @memberof SystemGenerateObject35
     */
    'conditions'?: PartialBaseTenantAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject35
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject35
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject36
 */
export interface SystemGenerateObject36 {
    /**
     * 
     * @type {PartialBaseTenantAdminVo}
     * @memberof SystemGenerateObject36
     */
    'conditions'?: PartialBaseTenantAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject36
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject36
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject36
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject37
 */
export interface SystemGenerateObject37 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject37
     */
    'userId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SystemGenerateObject37
     */
    'isRead'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject37
     */
    'msgType'?: string;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject37
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject37
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject37
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject38
 */
export interface SystemGenerateObject38 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject38
     */
    'msgType'?: string;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject38
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject38
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject38
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject39
 */
export interface SystemGenerateObject39 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject39
     */
    'messageId'?: number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject4
 */
export interface SystemGenerateObject4 {
    /**
     * 
     * @type {PartialBaseOperateAdminVo}
     * @memberof SystemGenerateObject4
     */
    'conditions'?: PartialBaseOperateAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject4
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject4
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject40
 */
export interface SystemGenerateObject40 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject40
     */
    'messageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject40
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject41
 */
export interface SystemGenerateObject41 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject41
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject42
 */
export interface SystemGenerateObject42 {
    /**
     * 
     * @type {PartialBaseMessageAdminVo}
     * @memberof SystemGenerateObject42
     */
    'conditions'?: PartialBaseMessageAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject42
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject42
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject43
 */
export interface SystemGenerateObject43 {
    /**
     * 
     * @type {PartialBaseMessageAdminVo}
     * @memberof SystemGenerateObject43
     */
    'conditions'?: PartialBaseMessageAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject43
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject43
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject43
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject44
 */
export interface SystemGenerateObject44 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject44
     */
    'messageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject44
     */
    'tenantId'?: number;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject45
 */
export interface SystemGenerateObject45 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject45
     */
    'balanceType'?: string;
    /**
     * 
     * @type {PartialBaseBalanceRecordAdminVo}
     * @memberof SystemGenerateObject45
     */
    'conditions'?: PartialBaseBalanceRecordAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject45
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject45
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject45
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject46
 */
export interface SystemGenerateObject46 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject46
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject46
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject46
     */
    'balanceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject46
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject46
     */
    'refId'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject47
 */
export interface SystemGenerateObject47 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject47
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject47
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject47
     */
    'balanceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject47
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject47
     */
    'refId'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject48
 */
export interface SystemGenerateObject48 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject48
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject48
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject48
     */
    'balanceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject48
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject48
     */
    'refId'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject49
 */
export interface SystemGenerateObject49 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject49
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject49
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject49
     */
    'balanceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject49
     */
    'remark'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject49
     */
    'refId'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject5
 */
export interface SystemGenerateObject5 {
    /**
     * 
     * @type {PartialBaseOperateAdminVo}
     * @memberof SystemGenerateObject5
     */
    'conditions'?: PartialBaseOperateAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject5
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject5
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject5
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject50
 */
export interface SystemGenerateObject50 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject50
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject50
     */
    'platform'?: string;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject50
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject50
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject50
     */
    'body'?: string;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject50
     */
    'expireMinutes'?: number;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject50
     */
    'extra'?: any;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject51
 */
export interface SystemGenerateObject51 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject51
     */
    'orderNo'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject52
 */
export interface SystemGenerateObject52 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject52
     */
    'orderNo'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject53
 */
export interface SystemGenerateObject53 {
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject53
     */
    'userId'?: number;
    /**
     * 
     * @type {PartialBasePaymentOrderAdminVo}
     * @memberof SystemGenerateObject53
     */
    'conditions'?: PartialBasePaymentOrderAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject53
     */
    'pageQuery'?: BasePageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject54
 */
export interface SystemGenerateObject54 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject54
     */
    'orderNo'?: string;
    /**
     * 
     * @type {number}
     * @memberof SystemGenerateObject54
     */
    'refundAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject54
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject55
 */
export interface SystemGenerateObject55 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject55
     */
    'orderNo'?: string;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject55
     */
    'pageQuery'?: BasePageQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject56
 */
export interface SystemGenerateObject56 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject56
     */
    'platform'?: string;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject56
     */
    'rawBody'?: any;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject56
     */
    'headers'?: any;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject56
     */
    'orderNoHint'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject57
 */
export interface SystemGenerateObject57 {
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject57
     */
    'platform'?: string;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject57
     */
    'rawBody'?: any;
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject57
     */
    'headers'?: any;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject57
     */
    'refundNoHint'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject59
 */
export interface SystemGenerateObject59 {
    /**
     * 
     * @type {SearchTrackLoginVo}
     * @memberof SystemGenerateObject59
     */
    'loginVo': SearchTrackLoginVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject6
 */
export interface SystemGenerateObject6 {
    /**
     * 
     * @type {PartialBaseRouteAdminVo}
     * @memberof SystemGenerateObject6
     */
    'conditions'?: PartialBaseRouteAdminVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject6
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject6
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject60
 */
export interface SystemGenerateObject60 {
    /**
     * 
     * @type {SearchTrackProfileUpdateVo}
     * @memberof SystemGenerateObject60
     */
    'profileUpdateVo': SearchTrackProfileUpdateVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject62
 */
export interface SystemGenerateObject62 {
    /**
     * 
     * @type {SearchTrackStationVo}
     * @memberof SystemGenerateObject62
     */
    'stationVo': SearchTrackStationVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject63
 */
export interface SystemGenerateObject63 {
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject63
     */
    'stationVo': any;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject64
 */
export interface SystemGenerateObject64 {
    /**
     * 
     * @type {SearchTrackAccountVo}
     * @memberof SystemGenerateObject64
     */
    'accountVo': SearchTrackAccountVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject65
 */
export interface SystemGenerateObject65 {
    /**
     * 
     * @type {any}
     * @memberof SystemGenerateObject65
     */
    'accountVo': any;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject66
 */
export interface SystemGenerateObject66 {
    /**
     * 
     * @type {SearchTrackQrcodeBindVo}
     * @memberof SystemGenerateObject66
     */
    'bindVo': SearchTrackQrcodeBindVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject67
 */
export interface SystemGenerateObject67 {
    /**
     * 
     * @type {SearchTrackQrcodeGenerateVo}
     * @memberof SystemGenerateObject67
     */
    'generateVo': SearchTrackQrcodeGenerateVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject68
 */
export interface SystemGenerateObject68 {
    /**
     * 
     * @type {SearchTrackParcelQueryVo}
     * @memberof SystemGenerateObject68
     */
    'parcelQueryVo': SearchTrackParcelQueryVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject69
 */
export interface SystemGenerateObject69 {
    /**
     * 
     * @type {SearchTrackParcelSmsSendVo}
     * @memberof SystemGenerateObject69
     */
    'sendVo': SearchTrackParcelSmsSendVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject7
 */
export interface SystemGenerateObject7 {
    /**
     * 
     * @type {PartialBaseRouteAdminVo}
     * @memberof SystemGenerateObject7
     */
    'conditions'?: PartialBaseRouteAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject7
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject7
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject7
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject70
 */
export interface SystemGenerateObject70 {
    /**
     * 
     * @type {SearchTrackParcelSmsSubmitVo}
     * @memberof SystemGenerateObject70
     */
    'submitVo': SearchTrackParcelSmsSubmitVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject71
 */
export interface SystemGenerateObject71 {
    /**
     * 
     * @type {SearchTrackParcelSmsSendVo}
     * @memberof SystemGenerateObject71
     */
    'sendVo': SearchTrackParcelSmsSendVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject72
 */
export interface SystemGenerateObject72 {
    /**
     * 
     * @type {SearchTrackStationVo}
     * @memberof SystemGenerateObject72
     */
    'stationVo': SearchTrackStationVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject73
 */
export interface SystemGenerateObject73 {
    /**
     * 
     * @type {SearchTrackStationVo}
     * @memberof SystemGenerateObject73
     */
    'stationVo': SearchTrackStationVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject74
 */
export interface SystemGenerateObject74 {
    /**
     * 
     * @type {SearchTrackAccountVo}
     * @memberof SystemGenerateObject74
     */
    'accountVo': SearchTrackAccountVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject75
 */
export interface SystemGenerateObject75 {
    /**
     * 
     * @type {SearchTrackAccountVo}
     * @memberof SystemGenerateObject75
     */
    'accountVo': SearchTrackAccountVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject76
 */
export interface SystemGenerateObject76 {
    /**
     * 
     * @type {SearchTrackQrcodeBatchVo}
     * @memberof SystemGenerateObject76
     */
    'batchVo': SearchTrackQrcodeBatchVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject77
 */
export interface SystemGenerateObject77 {
    /**
     * 
     * @type {SearchTrackQrcodeGenerateVo}
     * @memberof SystemGenerateObject77
     */
    'generateVo': SearchTrackQrcodeGenerateVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject78
 */
export interface SystemGenerateObject78 {
    /**
     * 
     * @type {SearchTrackQrcodeRefreshVo}
     * @memberof SystemGenerateObject78
     */
    'refreshVo': SearchTrackQrcodeRefreshVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject79
 */
export interface SystemGenerateObject79 {
    /**
     * 
     * @type {SearchTrackQrcodeBindSchemeVo}
     * @memberof SystemGenerateObject79
     */
    'bindVo': SearchTrackQrcodeBindSchemeVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject8
 */
export interface SystemGenerateObject8 {
    /**
     * 
     * @type {PartialBaseScheduleAdminVo}
     * @memberof SystemGenerateObject8
     */
    'conditions'?: PartialBaseScheduleAdminVo;
    /**
     * 
     * @type {BasePageQueryVo}
     * @memberof SystemGenerateObject8
     */
    'pageQuery'?: BasePageQueryVo;
    /**
     * 
     * @type {Array<BaseOrderByVo>}
     * @memberof SystemGenerateObject8
     */
    'orderBys'?: Array<BaseOrderByVo>;
    /**
     * 
     * @type {string}
     * @memberof SystemGenerateObject8
     */
    'queryKey'?: string;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject80
 */
export interface SystemGenerateObject80 {
    /**
     * 
     * @type {SearchTrackQrcodeBatchIdsVo}
     * @memberof SystemGenerateObject80
     */
    'batchIdsVo'?: SearchTrackQrcodeBatchIdsVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject81
 */
export interface SystemGenerateObject81 {
    /**
     * 
     * @type {SearchTrackQrcodeBatchIdsVo}
     * @memberof SystemGenerateObject81
     */
    'batchIdsVo'?: SearchTrackQrcodeBatchIdsVo;
}
/**
 * 
 * @export
 * @interface SystemGenerateObject82
 */
export interface SystemGenerateObject82 {
    /**
     * 
     * @type {SearchTrackAgreementSaveVo}
     * @memberof SystemGenerateObject82
     */
    'agreementSaveVo': SearchTrackAgreementSaveVo;
}

/**
 * BaseApiApi - axios parameter creator
 * @export
 */
export const BaseApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 获取接口列表
         * @param {SystemGenerateObject1} systemGenerateObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApisBaseApi: async (systemGenerateObject1: SystemGenerateObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject1' is not null or undefined
            assertParamExists('listApisBaseApi', 'systemGenerateObject1', systemGenerateObject1)
            const localVarPath = `/__base/api/listApis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改接口
         * @param {BaseApiAdminVo} baseApiAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiBaseApi: async (baseApiAdminVo: BaseApiAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseApiAdminVo' is not null or undefined
            assertParamExists('updateApiBaseApi', 'baseApiAdminVo', baseApiAdminVo)
            const localVarPath = `/__base/api/updateApi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseApiAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseApiApi - functional programming interface
 * @export
 */
export const BaseApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 获取接口列表
         * @param {SystemGenerateObject1} systemGenerateObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApisBaseApi(systemGenerateObject1: SystemGenerateObject1, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApisBaseApi(systemGenerateObject1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改接口
         * @param {BaseApiAdminVo} baseApiAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApiBaseApi(baseApiAdminVo: BaseApiAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApiBaseApi(baseApiAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseApiApi - factory interface
 * @export
 */
export const BaseApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseApiApiFp(configuration)
    return {
        /**
         * 
         * @summary 获取接口列表
         * @param {SystemGenerateObject1} systemGenerateObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApisBaseApi(systemGenerateObject1: SystemGenerateObject1, options?: any): AxiosPromise<any> {
            return localVarFp.listApisBaseApi(systemGenerateObject1, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改接口
         * @param {BaseApiAdminVo} baseApiAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiBaseApi(baseApiAdminVo: BaseApiAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateApiBaseApi(baseApiAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseApiApi - object-oriented interface
 * @export
 * @class BaseApiApi
 * @extends {BaseAPI}
 */
export class BaseApiApi extends BaseAPI {
    /**
     * 
     * @summary 获取接口列表
     * @param {SystemGenerateObject1} systemGenerateObject1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseApiApi
     */
    public listApisBaseApi(systemGenerateObject1: SystemGenerateObject1, options?: AxiosRequestConfig) {
        return BaseApiApiFp(this.configuration).listApisBaseApi(systemGenerateObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改接口
     * @param {BaseApiAdminVo} baseApiAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseApiApi
     */
    public updateApiBaseApi(baseApiAdminVo: BaseApiAdminVo, options?: AxiosRequestConfig) {
        return BaseApiApiFp(this.configuration).updateApiBaseApi(baseApiAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseBalanceApi - axios parameter creator
 * @export
 */
export const BaseBalanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 管理员调整余额
         * @param {SystemGenerateObject49} systemGenerateObject49 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustBaseBalance: async (systemGenerateObject49: SystemGenerateObject49, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject49' is not null or undefined
            assertParamExists('adjustBaseBalance', 'systemGenerateObject49', systemGenerateObject49)
            const localVarPath = `/__base/balance/adjust`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject49, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 消费/扣款
         * @param {SystemGenerateObject47} systemGenerateObject47 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeBaseBalance: async (systemGenerateObject47: SystemGenerateObject47, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject47' is not null or undefined
            assertParamExists('consumeBaseBalance', 'systemGenerateObject47', systemGenerateObject47)
            const localVarPath = `/__base/balance/consume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject47, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取用户余额
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceBaseBalance: async (userId: number, balanceType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getBalanceBaseBalance', 'userId', userId)
            // verify required parameter 'balanceType' is not null or undefined
            assertParamExists('getBalanceBaseBalance', 'balanceType', balanceType)
            const localVarPath = `/__base/balance/getBalance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (balanceType !== undefined) {
                localVarQueryParameter['balanceType'] = balanceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查询余额变动记录(不分页)
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecordsBaseBalance: async (userId: number, balanceType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listRecordsBaseBalance', 'userId', userId)
            // verify required parameter 'balanceType' is not null or undefined
            assertParamExists('listRecordsBaseBalance', 'balanceType', balanceType)
            const localVarPath = `/__base/balance/listRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (balanceType !== undefined) {
                localVarQueryParameter['balanceType'] = balanceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分页查询余额变动记录
         * @param {SystemGenerateObject45} systemGenerateObject45 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecordsBaseBalance: async (systemGenerateObject45: SystemGenerateObject45, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject45' is not null or undefined
            assertParamExists('pageRecordsBaseBalance', 'systemGenerateObject45', systemGenerateObject45)
            const localVarPath = `/__base/balance/pageRecords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject45, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 充值
         * @param {SystemGenerateObject46} systemGenerateObject46 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechargeBaseBalance: async (systemGenerateObject46: SystemGenerateObject46, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject46' is not null or undefined
            assertParamExists('rechargeBaseBalance', 'systemGenerateObject46', systemGenerateObject46)
            const localVarPath = `/__base/balance/recharge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject46, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 退款(增加余额)
         * @param {SystemGenerateObject48} systemGenerateObject48 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundBaseBalance: async (systemGenerateObject48: SystemGenerateObject48, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject48' is not null or undefined
            assertParamExists('refundBaseBalance', 'systemGenerateObject48', systemGenerateObject48)
            const localVarPath = `/__base/balance/refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject48, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseBalanceApi - functional programming interface
 * @export
 */
export const BaseBalanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseBalanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 管理员调整余额
         * @param {SystemGenerateObject49} systemGenerateObject49 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adjustBaseBalance(systemGenerateObject49: SystemGenerateObject49, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adjustBaseBalance(systemGenerateObject49, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 消费/扣款
         * @param {SystemGenerateObject47} systemGenerateObject47 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consumeBaseBalance(systemGenerateObject47: SystemGenerateObject47, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consumeBaseBalance(systemGenerateObject47, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取用户余额
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalanceBaseBalance(userId: number, balanceType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalanceBaseBalance(userId, balanceType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查询余额变动记录(不分页)
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecordsBaseBalance(userId: number, balanceType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecordsBaseBalance(userId, balanceType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 分页查询余额变动记录
         * @param {SystemGenerateObject45} systemGenerateObject45 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRecordsBaseBalance(systemGenerateObject45: SystemGenerateObject45, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRecordsBaseBalance(systemGenerateObject45, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 充值
         * @param {SystemGenerateObject46} systemGenerateObject46 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rechargeBaseBalance(systemGenerateObject46: SystemGenerateObject46, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rechargeBaseBalance(systemGenerateObject46, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 退款(增加余额)
         * @param {SystemGenerateObject48} systemGenerateObject48 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundBaseBalance(systemGenerateObject48: SystemGenerateObject48, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundBaseBalance(systemGenerateObject48, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseBalanceApi - factory interface
 * @export
 */
export const BaseBalanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseBalanceApiFp(configuration)
    return {
        /**
         * 
         * @summary 管理员调整余额
         * @param {SystemGenerateObject49} systemGenerateObject49 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustBaseBalance(systemGenerateObject49: SystemGenerateObject49, options?: any): AxiosPromise<any> {
            return localVarFp.adjustBaseBalance(systemGenerateObject49, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 消费/扣款
         * @param {SystemGenerateObject47} systemGenerateObject47 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeBaseBalance(systemGenerateObject47: SystemGenerateObject47, options?: any): AxiosPromise<any> {
            return localVarFp.consumeBaseBalance(systemGenerateObject47, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取用户余额
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceBaseBalance(userId: number, balanceType: string, options?: any): AxiosPromise<any> {
            return localVarFp.getBalanceBaseBalance(userId, balanceType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查询余额变动记录(不分页)
         * @param {number} userId 
         * @param {string} balanceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecordsBaseBalance(userId: number, balanceType: string, options?: any): AxiosPromise<any> {
            return localVarFp.listRecordsBaseBalance(userId, balanceType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分页查询余额变动记录
         * @param {SystemGenerateObject45} systemGenerateObject45 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRecordsBaseBalance(systemGenerateObject45: SystemGenerateObject45, options?: any): AxiosPromise<any> {
            return localVarFp.pageRecordsBaseBalance(systemGenerateObject45, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 充值
         * @param {SystemGenerateObject46} systemGenerateObject46 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechargeBaseBalance(systemGenerateObject46: SystemGenerateObject46, options?: any): AxiosPromise<any> {
            return localVarFp.rechargeBaseBalance(systemGenerateObject46, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 退款(增加余额)
         * @param {SystemGenerateObject48} systemGenerateObject48 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundBaseBalance(systemGenerateObject48: SystemGenerateObject48, options?: any): AxiosPromise<any> {
            return localVarFp.refundBaseBalance(systemGenerateObject48, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseBalanceApi - object-oriented interface
 * @export
 * @class BaseBalanceApi
 * @extends {BaseAPI}
 */
export class BaseBalanceApi extends BaseAPI {
    /**
     * 
     * @summary 管理员调整余额
     * @param {SystemGenerateObject49} systemGenerateObject49 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public adjustBaseBalance(systemGenerateObject49: SystemGenerateObject49, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).adjustBaseBalance(systemGenerateObject49, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 消费/扣款
     * @param {SystemGenerateObject47} systemGenerateObject47 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public consumeBaseBalance(systemGenerateObject47: SystemGenerateObject47, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).consumeBaseBalance(systemGenerateObject47, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取用户余额
     * @param {number} userId 
     * @param {string} balanceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public getBalanceBaseBalance(userId: number, balanceType: string, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).getBalanceBaseBalance(userId, balanceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查询余额变动记录(不分页)
     * @param {number} userId 
     * @param {string} balanceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public listRecordsBaseBalance(userId: number, balanceType: string, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).listRecordsBaseBalance(userId, balanceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分页查询余额变动记录
     * @param {SystemGenerateObject45} systemGenerateObject45 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public pageRecordsBaseBalance(systemGenerateObject45: SystemGenerateObject45, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).pageRecordsBaseBalance(systemGenerateObject45, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 充值
     * @param {SystemGenerateObject46} systemGenerateObject46 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public rechargeBaseBalance(systemGenerateObject46: SystemGenerateObject46, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).rechargeBaseBalance(systemGenerateObject46, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 退款(增加余额)
     * @param {SystemGenerateObject48} systemGenerateObject48 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseBalanceApi
     */
    public refundBaseBalance(systemGenerateObject48: SystemGenerateObject48, options?: AxiosRequestConfig) {
        return BaseBalanceApiFp(this.configuration).refundBaseBalance(systemGenerateObject48, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseConfigApi - axios parameter creator
 * @export
 */
export const BaseConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 根据key删除单个配置项
         * @summary 删除配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteValueBaseConfig: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('deleteValueBaseConfig', 'key', key)
            const localVarPath = `/__base/config/deleteValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取系统完整配置信息
         * @summary 获取完整配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigBaseConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/config/getConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取前端运行时主题配置
         * @summary 获取主题配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemeConfigBaseConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/config/getThemeConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 根据key获取单个配置项的值
         * @summary 获取配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValueBaseConfig: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getValueBaseConfig', 'key', key)
            const localVarPath = `/__base/config/getValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 根据key设置单个配置项的值
         * @summary 设置配置项
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setValueBaseConfig: async (body: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setValueBaseConfig', 'body', body)
            const localVarPath = `/__base/config/setValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseConfigApi - functional programming interface
 * @export
 */
export const BaseConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 根据key删除单个配置项
         * @summary 删除配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteValueBaseConfig(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteValueBaseConfig(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取系统完整配置信息
         * @summary 获取完整配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigBaseConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigBaseConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取前端运行时主题配置
         * @summary 获取主题配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThemeConfigBaseConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getThemeConfigBaseConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 根据key获取单个配置项的值
         * @summary 获取配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValueBaseConfig(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValueBaseConfig(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 根据key设置单个配置项的值
         * @summary 设置配置项
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setValueBaseConfig(body: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setValueBaseConfig(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseConfigApi - factory interface
 * @export
 */
export const BaseConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseConfigApiFp(configuration)
    return {
        /**
         * 根据key删除单个配置项
         * @summary 删除配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteValueBaseConfig(key: string, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteValueBaseConfig(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取系统完整配置信息
         * @summary 获取完整配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigBaseConfig(options?: any): AxiosPromise<any> {
            return localVarFp.getConfigBaseConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 获取前端运行时主题配置
         * @summary 获取主题配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemeConfigBaseConfig(options?: any): AxiosPromise<any> {
            return localVarFp.getThemeConfigBaseConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 根据key获取单个配置项的值
         * @summary 获取配置项
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValueBaseConfig(key: string, options?: any): AxiosPromise<any> {
            return localVarFp.getValueBaseConfig(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 根据key设置单个配置项的值
         * @summary 设置配置项
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setValueBaseConfig(body: any, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.setValueBaseConfig(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseConfigApi - object-oriented interface
 * @export
 * @class BaseConfigApi
 * @extends {BaseAPI}
 */
export class BaseConfigApi extends BaseAPI {
    /**
     * 根据key删除单个配置项
     * @summary 删除配置项
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public deleteValueBaseConfig(key: string, options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).deleteValueBaseConfig(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取系统完整配置信息
     * @summary 获取完整配置
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public getConfigBaseConfig(options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).getConfigBaseConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取前端运行时主题配置
     * @summary 获取主题配置
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public getThemeConfigBaseConfig(options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).getThemeConfigBaseConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 根据key获取单个配置项的值
     * @summary 获取配置项
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public getValueBaseConfig(key: string, options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).getValueBaseConfig(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 根据key设置单个配置项的值
     * @summary 设置配置项
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseConfigApi
     */
    public setValueBaseConfig(body: any, options?: AxiosRequestConfig) {
        return BaseConfigApiFp(this.configuration).setValueBaseConfig(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseDictionaryApi - axios parameter creator
 * @export
 */
export const BaseDictionaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDictionaryBaseDictionary: async (baseDictionaryAdminVo: BaseDictionaryAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseDictionaryAdminVo' is not null or undefined
            assertParamExists('addDictionaryBaseDictionary', 'baseDictionaryAdminVo', baseDictionaryAdminVo)
            const localVarPath = `/__base/dictionary/addDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseDictionaryAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除字典
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDictionaryBaseDictionary: async (dictionaryId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryId' is not null or undefined
            assertParamExists('delDictionaryBaseDictionary', 'dictionaryId', dictionaryId)
            const localVarPath = `/__base/dictionary/delDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dictionaryId !== undefined) {
                localVarQueryParameter['dictionaryId'] = dictionaryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取单个字典
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryBaseDictionary: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getDictionaryBaseDictionary', 'key', key)
            const localVarPath = `/__base/dictionary/getDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取字典列表
         * @param {SystemGenerateObject33} systemGenerateObject33 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDictionaryBaseDictionary: async (systemGenerateObject33: SystemGenerateObject33, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject33' is not null or undefined
            assertParamExists('listDictionaryBaseDictionary', 'systemGenerateObject33', systemGenerateObject33)
            const localVarPath = `/__base/dictionary/listDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject33, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取字典列表(分页)
         * @param {SystemGenerateObject34} systemGenerateObject34 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDictionaryBaseDictionary: async (systemGenerateObject34: SystemGenerateObject34, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject34' is not null or undefined
            assertParamExists('pageDictionaryBaseDictionary', 'systemGenerateObject34', systemGenerateObject34)
            const localVarPath = `/__base/dictionary/pageDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject34, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryBaseDictionary: async (baseDictionaryAdminVo: BaseDictionaryAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseDictionaryAdminVo' is not null or undefined
            assertParamExists('updateDictionaryBaseDictionary', 'baseDictionaryAdminVo', baseDictionaryAdminVo)
            const localVarPath = `/__base/dictionary/updateDictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseDictionaryAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseDictionaryApi - functional programming interface
 * @export
 */
export const BaseDictionaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseDictionaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDictionaryBaseDictionary(baseDictionaryAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除字典
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delDictionaryBaseDictionary(dictionaryId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delDictionaryBaseDictionary(dictionaryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取单个字典
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDictionaryBaseDictionary(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDictionaryBaseDictionary(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取字典列表
         * @param {SystemGenerateObject33} systemGenerateObject33 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDictionaryBaseDictionary(systemGenerateObject33: SystemGenerateObject33, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDictionaryBaseDictionary(systemGenerateObject33, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取字典列表(分页)
         * @param {SystemGenerateObject34} systemGenerateObject34 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageDictionaryBaseDictionary(systemGenerateObject34: SystemGenerateObject34, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageDictionaryBaseDictionary(systemGenerateObject34, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDictionaryBaseDictionary(baseDictionaryAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseDictionaryApi - factory interface
 * @export
 */
export const BaseDictionaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseDictionaryApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除字典
         * @param {number} dictionaryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delDictionaryBaseDictionary(dictionaryId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delDictionaryBaseDictionary(dictionaryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取单个字典
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDictionaryBaseDictionary(key: string, options?: any): AxiosPromise<any> {
            return localVarFp.getDictionaryBaseDictionary(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取字典列表
         * @param {SystemGenerateObject33} systemGenerateObject33 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDictionaryBaseDictionary(systemGenerateObject33: SystemGenerateObject33, options?: any): AxiosPromise<any> {
            return localVarFp.listDictionaryBaseDictionary(systemGenerateObject33, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取字典列表(分页)
         * @param {SystemGenerateObject34} systemGenerateObject34 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageDictionaryBaseDictionary(systemGenerateObject34: SystemGenerateObject34, options?: any): AxiosPromise<any> {
            return localVarFp.pageDictionaryBaseDictionary(systemGenerateObject34, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改字典
         * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseDictionaryApi - object-oriented interface
 * @export
 * @class BaseDictionaryApi
 * @extends {BaseAPI}
 */
export class BaseDictionaryApi extends BaseAPI {
    /**
     * 
     * @summary 添加字典
     * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public addDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).addDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除字典
     * @param {number} dictionaryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public delDictionaryBaseDictionary(dictionaryId: number, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).delDictionaryBaseDictionary(dictionaryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取单个字典
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public getDictionaryBaseDictionary(key: string, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).getDictionaryBaseDictionary(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取字典列表
     * @param {SystemGenerateObject33} systemGenerateObject33 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public listDictionaryBaseDictionary(systemGenerateObject33: SystemGenerateObject33, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).listDictionaryBaseDictionary(systemGenerateObject33, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取字典列表(分页)
     * @param {SystemGenerateObject34} systemGenerateObject34 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public pageDictionaryBaseDictionary(systemGenerateObject34: SystemGenerateObject34, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).pageDictionaryBaseDictionary(systemGenerateObject34, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改字典
     * @param {BaseDictionaryAdminVo} baseDictionaryAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseDictionaryApi
     */
    public updateDictionaryBaseDictionary(baseDictionaryAdminVo: BaseDictionaryAdminVo, options?: AxiosRequestConfig) {
        return BaseDictionaryApiFp(this.configuration).updateDictionaryBaseDictionary(baseDictionaryAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseLogApi - axios parameter creator
 * @export
 */
export const BaseLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 删除日志
         * @param {SystemGenerateObject32} systemGenerateObject32 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogBaseLog: async (systemGenerateObject32: SystemGenerateObject32, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject32' is not null or undefined
            assertParamExists('deleteLogBaseLog', 'systemGenerateObject32', systemGenerateObject32)
            const localVarPath = `/__base/log/deleteLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject32, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取日志数量
         * @param {SystemGenerateObject29} systemGenerateObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountBaseLog: async (systemGenerateObject29: SystemGenerateObject29, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject29' is not null or undefined
            assertParamExists('getCountBaseLog', 'systemGenerateObject29', systemGenerateObject29)
            const localVarPath = `/__base/log/getCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject29, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject30} systemGenerateObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLogBaseLog: async (systemGenerateObject30: SystemGenerateObject30, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject30' is not null or undefined
            assertParamExists('listLogBaseLog', 'systemGenerateObject30', systemGenerateObject30)
            const localVarPath = `/__base/log/listLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject30, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject31} systemGenerateObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageLogBaseLog: async (systemGenerateObject31: SystemGenerateObject31, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject31' is not null or undefined
            assertParamExists('pageLogBaseLog', 'systemGenerateObject31', systemGenerateObject31)
            const localVarPath = `/__base/log/pageLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject31, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseLogApi - functional programming interface
 * @export
 */
export const BaseLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 删除日志
         * @param {SystemGenerateObject32} systemGenerateObject32 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLogBaseLog(systemGenerateObject32: SystemGenerateObject32, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLogBaseLog(systemGenerateObject32, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取日志数量
         * @param {SystemGenerateObject29} systemGenerateObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountBaseLog(systemGenerateObject29: SystemGenerateObject29, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountBaseLog(systemGenerateObject29, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject30} systemGenerateObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLogBaseLog(systemGenerateObject30: SystemGenerateObject30, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLogBaseLog(systemGenerateObject30, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject31} systemGenerateObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageLogBaseLog(systemGenerateObject31: SystemGenerateObject31, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageLogBaseLog(systemGenerateObject31, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseLogApi - factory interface
 * @export
 */
export const BaseLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseLogApiFp(configuration)
    return {
        /**
         * 
         * @summary 删除日志
         * @param {SystemGenerateObject32} systemGenerateObject32 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogBaseLog(systemGenerateObject32: SystemGenerateObject32, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteLogBaseLog(systemGenerateObject32, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取日志数量
         * @param {SystemGenerateObject29} systemGenerateObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountBaseLog(systemGenerateObject29: SystemGenerateObject29, options?: any): AxiosPromise<any> {
            return localVarFp.getCountBaseLog(systemGenerateObject29, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject30} systemGenerateObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLogBaseLog(systemGenerateObject30: SystemGenerateObject30, options?: any): AxiosPromise<any> {
            return localVarFp.listLogBaseLog(systemGenerateObject30, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject31} systemGenerateObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageLogBaseLog(systemGenerateObject31: SystemGenerateObject31, options?: any): AxiosPromise<any> {
            return localVarFp.pageLogBaseLog(systemGenerateObject31, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseLogApi - object-oriented interface
 * @export
 * @class BaseLogApi
 * @extends {BaseAPI}
 */
export class BaseLogApi extends BaseAPI {
    /**
     * 
     * @summary 删除日志
     * @param {SystemGenerateObject32} systemGenerateObject32 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public deleteLogBaseLog(systemGenerateObject32: SystemGenerateObject32, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).deleteLogBaseLog(systemGenerateObject32, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取日志数量
     * @param {SystemGenerateObject29} systemGenerateObject29 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public getCountBaseLog(systemGenerateObject29: SystemGenerateObject29, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).getCountBaseLog(systemGenerateObject29, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取操作列表
     * @param {SystemGenerateObject30} systemGenerateObject30 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public listLogBaseLog(systemGenerateObject30: SystemGenerateObject30, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).listLogBaseLog(systemGenerateObject30, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取操作列表(分页)
     * @param {SystemGenerateObject31} systemGenerateObject31 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseLogApi
     */
    public pageLogBaseLog(systemGenerateObject31: SystemGenerateObject31, options?: AxiosRequestConfig) {
        return BaseLogApiFp(this.configuration).pageLogBaseLog(systemGenerateObject31, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseMenuApi - axios parameter creator
 * @export
 */
export const BaseMenuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMenuBaseMenu: async (baseMenuAdminVo: BaseMenuAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMenuAdminVo' is not null or undefined
            assertParamExists('addMenuBaseMenu', 'baseMenuAdminVo', baseMenuAdminVo)
            const localVarPath = `/__base/menu/addMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMenuAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除菜单
         * @param {number} menuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMenuBaseMenu: async (menuId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'menuId' is not null or undefined
            assertParamExists('delMenuBaseMenu', 'menuId', menuId)
            const localVarPath = `/__base/menu/delMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取动态菜单
         * @summary 获取动态菜单
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getsBaseMenu: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/menu/gets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取菜单列表
         * @param {SystemGenerateObject2} systemGenerateObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenusBaseMenu: async (systemGenerateObject2: SystemGenerateObject2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject2' is not null or undefined
            assertParamExists('listMenusBaseMenu', 'systemGenerateObject2', systemGenerateObject2)
            const localVarPath = `/__base/menu/listMenus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取菜单列表(分页)
         * @param {SystemGenerateObject3} systemGenerateObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMenusBaseMenu: async (systemGenerateObject3: SystemGenerateObject3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject3' is not null or undefined
            assertParamExists('pageMenusBaseMenu', 'systemGenerateObject3', systemGenerateObject3)
            const localVarPath = `/__base/menu/pageMenus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuBaseMenu: async (baseMenuAdminVo: BaseMenuAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMenuAdminVo' is not null or undefined
            assertParamExists('updateMenuBaseMenu', 'baseMenuAdminVo', baseMenuAdminVo)
            const localVarPath = `/__base/menu/updateMenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMenuAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseMenuApi - functional programming interface
 * @export
 */
export const BaseMenuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseMenuApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMenuBaseMenu(baseMenuAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除菜单
         * @param {number} menuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delMenuBaseMenu(menuId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delMenuBaseMenu(menuId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取动态菜单
         * @summary 获取动态菜单
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getsBaseMenu(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getsBaseMenu(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取菜单列表
         * @param {SystemGenerateObject2} systemGenerateObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMenusBaseMenu(systemGenerateObject2: SystemGenerateObject2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMenusBaseMenu(systemGenerateObject2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取菜单列表(分页)
         * @param {SystemGenerateObject3} systemGenerateObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMenusBaseMenu(systemGenerateObject3: SystemGenerateObject3, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMenusBaseMenu(systemGenerateObject3, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMenuBaseMenu(baseMenuAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseMenuApi - factory interface
 * @export
 */
export const BaseMenuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseMenuApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除菜单
         * @param {number} menuId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMenuBaseMenu(menuId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delMenuBaseMenu(menuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取动态菜单
         * @summary 获取动态菜单
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getsBaseMenu(options?: any): AxiosPromise<any> {
            return localVarFp.getsBaseMenu(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取菜单列表
         * @param {SystemGenerateObject2} systemGenerateObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenusBaseMenu(systemGenerateObject2: SystemGenerateObject2, options?: any): AxiosPromise<any> {
            return localVarFp.listMenusBaseMenu(systemGenerateObject2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取菜单列表(分页)
         * @param {SystemGenerateObject3} systemGenerateObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMenusBaseMenu(systemGenerateObject3: SystemGenerateObject3, options?: any): AxiosPromise<any> {
            return localVarFp.pageMenusBaseMenu(systemGenerateObject3, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改菜单
         * @param {BaseMenuAdminVo} baseMenuAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseMenuApi - object-oriented interface
 * @export
 * @class BaseMenuApi
 * @extends {BaseAPI}
 */
export class BaseMenuApi extends BaseAPI {
    /**
     * 
     * @summary 添加菜单
     * @param {BaseMenuAdminVo} baseMenuAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public addMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).addMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除菜单
     * @param {number} menuId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public delMenuBaseMenu(menuId: number, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).delMenuBaseMenu(menuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取动态菜单
     * @summary 获取动态菜单
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public getsBaseMenu(options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).getsBaseMenu(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取菜单列表
     * @param {SystemGenerateObject2} systemGenerateObject2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public listMenusBaseMenu(systemGenerateObject2: SystemGenerateObject2, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).listMenusBaseMenu(systemGenerateObject2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取菜单列表(分页)
     * @param {SystemGenerateObject3} systemGenerateObject3 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public pageMenusBaseMenu(systemGenerateObject3: SystemGenerateObject3, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).pageMenusBaseMenu(systemGenerateObject3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改菜单
     * @param {BaseMenuAdminVo} baseMenuAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMenuApi
     */
    public updateMenuBaseMenu(baseMenuAdminVo: BaseMenuAdminVo, options?: AxiosRequestConfig) {
        return BaseMenuApiFp(this.configuration).updateMenuBaseMenu(baseMenuAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseMessageApi - axios parameter creator
 * @export
 */
export const BaseMessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 删除消息(管理端)
         * @param {number} messageId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMessageBaseMessage: async (messageId: number, tenantId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('delMessageBaseMessage', 'messageId', messageId)
            const localVarPath = `/__base/message/delMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (messageId !== undefined) {
                localVarQueryParameter['messageId'] = messageId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除我的消息
         * @param {number} messageId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMyMessageBaseMessage: async (messageId: number, userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('delMyMessageBaseMessage', 'messageId', messageId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('delMyMessageBaseMessage', 'userId', userId)
            const localVarPath = `/__base/message/delMyMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (messageId !== undefined) {
                localVarQueryParameter['messageId'] = messageId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取私信功能配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivateMessageFeatureBaseMessage: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/message/getPrivateMessageFeature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取未读消息数
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCountBaseMessage: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUnreadCountBaseMessage', 'userId', userId)
            const localVarPath = `/__base/message/getUnreadCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取消息列表(管理端)
         * @param {SystemGenerateObject42} systemGenerateObject42 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessageBaseMessage: async (systemGenerateObject42: SystemGenerateObject42, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject42' is not null or undefined
            assertParamExists('listMessageBaseMessage', 'systemGenerateObject42', systemGenerateObject42)
            const localVarPath = `/__base/message/listMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject42, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查看消息接收情况
         * @param {SystemGenerateObject44} systemGenerateObject44 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessageReceiversBaseMessage: async (systemGenerateObject44: SystemGenerateObject44, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject44' is not null or undefined
            assertParamExists('listMessageReceiversBaseMessage', 'systemGenerateObject44', systemGenerateObject44)
            const localVarPath = `/__base/message/listMessageReceivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject44, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查看我发送消息的接收情况
         * @param {SystemGenerateObject39} systemGenerateObject39 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMySentReceiversBaseMessage: async (systemGenerateObject39: SystemGenerateObject39, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject39' is not null or undefined
            assertParamExists('listMySentReceiversBaseMessage', 'systemGenerateObject39', systemGenerateObject39)
            const localVarPath = `/__base/message/listMySentMessageReceivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject39, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取消息列表(管理端分页)
         * @param {SystemGenerateObject43} systemGenerateObject43 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMessageBaseMessage: async (systemGenerateObject43: SystemGenerateObject43, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject43' is not null or undefined
            assertParamExists('pageMessageBaseMessage', 'systemGenerateObject43', systemGenerateObject43)
            const localVarPath = `/__base/message/pageMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject43, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查询我的消息(分页)
         * @param {SystemGenerateObject37} systemGenerateObject37 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMyMessagesBaseMessage: async (systemGenerateObject37: SystemGenerateObject37, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject37' is not null or undefined
            assertParamExists('pageMyMessagesBaseMessage', 'systemGenerateObject37', systemGenerateObject37)
            const localVarPath = `/__base/message/pageMyMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject37, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查询我发送的消息(分页)
         * @param {SystemGenerateObject38} systemGenerateObject38 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSentMessagesBaseMessage: async (systemGenerateObject38: SystemGenerateObject38, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject38' is not null or undefined
            assertParamExists('pageSentMessagesBaseMessage', 'systemGenerateObject38', systemGenerateObject38)
            const localVarPath = `/__base/message/pageSentMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject38, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 全部标记已读
         * @param {SystemGenerateObject41} systemGenerateObject41 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllMessagesBaseMessage: async (systemGenerateObject41: SystemGenerateObject41, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject41' is not null or undefined
            assertParamExists('readAllMessagesBaseMessage', 'systemGenerateObject41', systemGenerateObject41)
            const localVarPath = `/__base/message/readAllMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject41, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 标记消息已读
         * @param {SystemGenerateObject40} systemGenerateObject40 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMessageBaseMessage: async (systemGenerateObject40: SystemGenerateObject40, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject40' is not null or undefined
            assertParamExists('readMessageBaseMessage', 'systemGenerateObject40', systemGenerateObject40)
            const localVarPath = `/__base/message/readMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject40, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 搜索私信接收用户
         * @param {BaseMessagePrivateUserSearchVo} baseMessagePrivateUserSearchVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPrivateMessageUsersBaseMessage: async (baseMessagePrivateUserSearchVo: BaseMessagePrivateUserSearchVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMessagePrivateUserSearchVo' is not null or undefined
            assertParamExists('searchPrivateMessageUsersBaseMessage', 'baseMessagePrivateUserSearchVo', baseMessagePrivateUserSearchVo)
            const localVarPath = `/__base/message/searchPrivateMessageUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMessagePrivateUserSearchVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发送消息
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageBaseMessage: async (baseMessageAdminVo: BaseMessageAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMessageAdminVo' is not null or undefined
            assertParamExists('sendMessageBaseMessage', 'baseMessageAdminVo', baseMessageAdminVo)
            const localVarPath = `/__base/message/sendMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMessageAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发送私信消息
         * @param {BaseMessagePrivateSendVo} baseMessagePrivateSendVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPrivateMessageBaseMessage: async (baseMessagePrivateSendVo: BaseMessagePrivateSendVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMessagePrivateSendVo' is not null or undefined
            assertParamExists('sendPrivateMessageBaseMessage', 'baseMessagePrivateSendVo', baseMessagePrivateSendVo)
            const localVarPath = `/__base/message/sendPrivateMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMessagePrivateSendVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改消息(管理端)
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageBaseMessage: async (baseMessageAdminVo: BaseMessageAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseMessageAdminVo' is not null or undefined
            assertParamExists('updateMessageBaseMessage', 'baseMessageAdminVo', baseMessageAdminVo)
            const localVarPath = `/__base/message/updateMessage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMessageAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseMessageApi - functional programming interface
 * @export
 */
export const BaseMessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseMessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 删除消息(管理端)
         * @param {number} messageId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delMessageBaseMessage(messageId: number, tenantId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delMessageBaseMessage(messageId, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除我的消息
         * @param {number} messageId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delMyMessageBaseMessage(messageId: number, userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delMyMessageBaseMessage(messageId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取私信功能配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrivateMessageFeatureBaseMessage(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrivateMessageFeatureBaseMessage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取未读消息数
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadCountBaseMessage(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadCountBaseMessage(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取消息列表(管理端)
         * @param {SystemGenerateObject42} systemGenerateObject42 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMessageBaseMessage(systemGenerateObject42: SystemGenerateObject42, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMessageBaseMessage(systemGenerateObject42, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查看消息接收情况
         * @param {SystemGenerateObject44} systemGenerateObject44 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMessageReceiversBaseMessage(systemGenerateObject44: SystemGenerateObject44, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMessageReceiversBaseMessage(systemGenerateObject44, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查看我发送消息的接收情况
         * @param {SystemGenerateObject39} systemGenerateObject39 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMySentReceiversBaseMessage(systemGenerateObject39: SystemGenerateObject39, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMySentReceiversBaseMessage(systemGenerateObject39, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取消息列表(管理端分页)
         * @param {SystemGenerateObject43} systemGenerateObject43 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMessageBaseMessage(systemGenerateObject43: SystemGenerateObject43, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMessageBaseMessage(systemGenerateObject43, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查询我的消息(分页)
         * @param {SystemGenerateObject37} systemGenerateObject37 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageMyMessagesBaseMessage(systemGenerateObject37: SystemGenerateObject37, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageMyMessagesBaseMessage(systemGenerateObject37, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查询我发送的消息(分页)
         * @param {SystemGenerateObject38} systemGenerateObject38 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSentMessagesBaseMessage(systemGenerateObject38: SystemGenerateObject38, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSentMessagesBaseMessage(systemGenerateObject38, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 全部标记已读
         * @param {SystemGenerateObject41} systemGenerateObject41 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readAllMessagesBaseMessage(systemGenerateObject41: SystemGenerateObject41, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readAllMessagesBaseMessage(systemGenerateObject41, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 标记消息已读
         * @param {SystemGenerateObject40} systemGenerateObject40 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readMessageBaseMessage(systemGenerateObject40: SystemGenerateObject40, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readMessageBaseMessage(systemGenerateObject40, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 搜索私信接收用户
         * @param {BaseMessagePrivateUserSearchVo} baseMessagePrivateUserSearchVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo: BaseMessagePrivateUserSearchVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发送消息
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMessageBaseMessage(baseMessageAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发送私信消息
         * @param {BaseMessagePrivateSendVo} baseMessagePrivateSendVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPrivateMessageBaseMessage(baseMessagePrivateSendVo: BaseMessagePrivateSendVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPrivateMessageBaseMessage(baseMessagePrivateSendVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改消息(管理端)
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMessageBaseMessage(baseMessageAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseMessageApi - factory interface
 * @export
 */
export const BaseMessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseMessageApiFp(configuration)
    return {
        /**
         * 
         * @summary 删除消息(管理端)
         * @param {number} messageId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMessageBaseMessage(messageId: number, tenantId?: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delMessageBaseMessage(messageId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除我的消息
         * @param {number} messageId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delMyMessageBaseMessage(messageId: number, userId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delMyMessageBaseMessage(messageId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取私信功能配置
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivateMessageFeatureBaseMessage(options?: any): AxiosPromise<any> {
            return localVarFp.getPrivateMessageFeatureBaseMessage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取未读消息数
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCountBaseMessage(userId: number, options?: any): AxiosPromise<any> {
            return localVarFp.getUnreadCountBaseMessage(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取消息列表(管理端)
         * @param {SystemGenerateObject42} systemGenerateObject42 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessageBaseMessage(systemGenerateObject42: SystemGenerateObject42, options?: any): AxiosPromise<any> {
            return localVarFp.listMessageBaseMessage(systemGenerateObject42, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查看消息接收情况
         * @param {SystemGenerateObject44} systemGenerateObject44 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessageReceiversBaseMessage(systemGenerateObject44: SystemGenerateObject44, options?: any): AxiosPromise<any> {
            return localVarFp.listMessageReceiversBaseMessage(systemGenerateObject44, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查看我发送消息的接收情况
         * @param {SystemGenerateObject39} systemGenerateObject39 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMySentReceiversBaseMessage(systemGenerateObject39: SystemGenerateObject39, options?: any): AxiosPromise<any> {
            return localVarFp.listMySentReceiversBaseMessage(systemGenerateObject39, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取消息列表(管理端分页)
         * @param {SystemGenerateObject43} systemGenerateObject43 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMessageBaseMessage(systemGenerateObject43: SystemGenerateObject43, options?: any): AxiosPromise<any> {
            return localVarFp.pageMessageBaseMessage(systemGenerateObject43, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查询我的消息(分页)
         * @param {SystemGenerateObject37} systemGenerateObject37 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageMyMessagesBaseMessage(systemGenerateObject37: SystemGenerateObject37, options?: any): AxiosPromise<any> {
            return localVarFp.pageMyMessagesBaseMessage(systemGenerateObject37, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查询我发送的消息(分页)
         * @param {SystemGenerateObject38} systemGenerateObject38 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSentMessagesBaseMessage(systemGenerateObject38: SystemGenerateObject38, options?: any): AxiosPromise<any> {
            return localVarFp.pageSentMessagesBaseMessage(systemGenerateObject38, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 全部标记已读
         * @param {SystemGenerateObject41} systemGenerateObject41 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllMessagesBaseMessage(systemGenerateObject41: SystemGenerateObject41, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.readAllMessagesBaseMessage(systemGenerateObject41, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 标记消息已读
         * @param {SystemGenerateObject40} systemGenerateObject40 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMessageBaseMessage(systemGenerateObject40: SystemGenerateObject40, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.readMessageBaseMessage(systemGenerateObject40, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 搜索私信接收用户
         * @param {BaseMessagePrivateUserSearchVo} baseMessagePrivateUserSearchVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo: BaseMessagePrivateUserSearchVo, options?: any): AxiosPromise<any> {
            return localVarFp.searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发送消息
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.sendMessageBaseMessage(baseMessageAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发送私信消息
         * @param {BaseMessagePrivateSendVo} baseMessagePrivateSendVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPrivateMessageBaseMessage(baseMessagePrivateSendVo: BaseMessagePrivateSendVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.sendPrivateMessageBaseMessage(baseMessagePrivateSendVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改消息(管理端)
         * @param {BaseMessageAdminVo} baseMessageAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateMessageBaseMessage(baseMessageAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseMessageApi - object-oriented interface
 * @export
 * @class BaseMessageApi
 * @extends {BaseAPI}
 */
export class BaseMessageApi extends BaseAPI {
    /**
     * 
     * @summary 删除消息(管理端)
     * @param {number} messageId 
     * @param {number} [tenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public delMessageBaseMessage(messageId: number, tenantId?: number, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).delMessageBaseMessage(messageId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除我的消息
     * @param {number} messageId 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public delMyMessageBaseMessage(messageId: number, userId: number, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).delMyMessageBaseMessage(messageId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取私信功能配置
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public getPrivateMessageFeatureBaseMessage(options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).getPrivateMessageFeatureBaseMessage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取未读消息数
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public getUnreadCountBaseMessage(userId: number, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).getUnreadCountBaseMessage(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取消息列表(管理端)
     * @param {SystemGenerateObject42} systemGenerateObject42 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public listMessageBaseMessage(systemGenerateObject42: SystemGenerateObject42, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).listMessageBaseMessage(systemGenerateObject42, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查看消息接收情况
     * @param {SystemGenerateObject44} systemGenerateObject44 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public listMessageReceiversBaseMessage(systemGenerateObject44: SystemGenerateObject44, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).listMessageReceiversBaseMessage(systemGenerateObject44, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查看我发送消息的接收情况
     * @param {SystemGenerateObject39} systemGenerateObject39 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public listMySentReceiversBaseMessage(systemGenerateObject39: SystemGenerateObject39, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).listMySentReceiversBaseMessage(systemGenerateObject39, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取消息列表(管理端分页)
     * @param {SystemGenerateObject43} systemGenerateObject43 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public pageMessageBaseMessage(systemGenerateObject43: SystemGenerateObject43, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).pageMessageBaseMessage(systemGenerateObject43, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查询我的消息(分页)
     * @param {SystemGenerateObject37} systemGenerateObject37 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public pageMyMessagesBaseMessage(systemGenerateObject37: SystemGenerateObject37, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).pageMyMessagesBaseMessage(systemGenerateObject37, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查询我发送的消息(分页)
     * @param {SystemGenerateObject38} systemGenerateObject38 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public pageSentMessagesBaseMessage(systemGenerateObject38: SystemGenerateObject38, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).pageSentMessagesBaseMessage(systemGenerateObject38, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 全部标记已读
     * @param {SystemGenerateObject41} systemGenerateObject41 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public readAllMessagesBaseMessage(systemGenerateObject41: SystemGenerateObject41, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).readAllMessagesBaseMessage(systemGenerateObject41, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 标记消息已读
     * @param {SystemGenerateObject40} systemGenerateObject40 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public readMessageBaseMessage(systemGenerateObject40: SystemGenerateObject40, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).readMessageBaseMessage(systemGenerateObject40, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 搜索私信接收用户
     * @param {BaseMessagePrivateUserSearchVo} baseMessagePrivateUserSearchVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo: BaseMessagePrivateUserSearchVo, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).searchPrivateMessageUsersBaseMessage(baseMessagePrivateUserSearchVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发送消息
     * @param {BaseMessageAdminVo} baseMessageAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public sendMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).sendMessageBaseMessage(baseMessageAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发送私信消息
     * @param {BaseMessagePrivateSendVo} baseMessagePrivateSendVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public sendPrivateMessageBaseMessage(baseMessagePrivateSendVo: BaseMessagePrivateSendVo, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).sendPrivateMessageBaseMessage(baseMessagePrivateSendVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改消息(管理端)
     * @param {BaseMessageAdminVo} baseMessageAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseMessageApi
     */
    public updateMessageBaseMessage(baseMessageAdminVo: BaseMessageAdminVo, options?: AxiosRequestConfig) {
        return BaseMessageApiFp(this.configuration).updateMessageBaseMessage(baseMessageAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseOperateApi - axios parameter creator
 * @export
 */
export const BaseOperateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOperateBaseOperate: async (baseOperateAdminVo: BaseOperateAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOperateAdminVo' is not null or undefined
            assertParamExists('addOperateBaseOperate', 'baseOperateAdminVo', baseOperateAdminVo)
            const localVarPath = `/__base/operate/addOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOperateAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除操作
         * @param {number} operateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOperateBaseOperate: async (operateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operateId' is not null or undefined
            assertParamExists('delOperateBaseOperate', 'operateId', operateId)
            const localVarPath = `/__base/operate/delOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operateId !== undefined) {
                localVarQueryParameter['operateId'] = operateId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取用户的操作列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatesBaseOperate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/operate/getOperates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject4} systemGenerateObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperateBaseOperate: async (systemGenerateObject4: SystemGenerateObject4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject4' is not null or undefined
            assertParamExists('listOperateBaseOperate', 'systemGenerateObject4', systemGenerateObject4)
            const localVarPath = `/__base/operate/listOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject5} systemGenerateObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOperateBaseOperate: async (systemGenerateObject5: SystemGenerateObject5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject5' is not null or undefined
            assertParamExists('pageOperateBaseOperate', 'systemGenerateObject5', systemGenerateObject5)
            const localVarPath = `/__base/operate/pageOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperateBaseOperate: async (baseOperateAdminVo: BaseOperateAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOperateAdminVo' is not null or undefined
            assertParamExists('updateOperateBaseOperate', 'baseOperateAdminVo', baseOperateAdminVo)
            const localVarPath = `/__base/operate/updateOperate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOperateAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseOperateApi - functional programming interface
 * @export
 */
export const BaseOperateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseOperateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOperateBaseOperate(baseOperateAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除操作
         * @param {number} operateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOperateBaseOperate(operateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOperateBaseOperate(operateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取用户的操作列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatesBaseOperate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatesBaseOperate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject4} systemGenerateObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOperateBaseOperate(systemGenerateObject4: SystemGenerateObject4, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOperateBaseOperate(systemGenerateObject4, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject5} systemGenerateObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOperateBaseOperate(systemGenerateObject5: SystemGenerateObject5, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOperateBaseOperate(systemGenerateObject5, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOperateBaseOperate(baseOperateAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseOperateApi - factory interface
 * @export
 */
export const BaseOperateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseOperateApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除操作
         * @param {number} operateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOperateBaseOperate(operateId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delOperateBaseOperate(operateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取用户的操作列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatesBaseOperate(options?: any): AxiosPromise<any> {
            return localVarFp.getOperatesBaseOperate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取操作列表
         * @param {SystemGenerateObject4} systemGenerateObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperateBaseOperate(systemGenerateObject4: SystemGenerateObject4, options?: any): AxiosPromise<any> {
            return localVarFp.listOperateBaseOperate(systemGenerateObject4, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取操作列表(分页)
         * @param {SystemGenerateObject5} systemGenerateObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOperateBaseOperate(systemGenerateObject5: SystemGenerateObject5, options?: any): AxiosPromise<any> {
            return localVarFp.pageOperateBaseOperate(systemGenerateObject5, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改操作
         * @param {BaseOperateAdminVo} baseOperateAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseOperateApi - object-oriented interface
 * @export
 * @class BaseOperateApi
 * @extends {BaseAPI}
 */
export class BaseOperateApi extends BaseAPI {
    /**
     * 
     * @summary 添加操作
     * @param {BaseOperateAdminVo} baseOperateAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public addOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).addOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除操作
     * @param {number} operateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public delOperateBaseOperate(operateId: number, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).delOperateBaseOperate(operateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取用户的操作列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public getOperatesBaseOperate(options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).getOperatesBaseOperate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取操作列表
     * @param {SystemGenerateObject4} systemGenerateObject4 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public listOperateBaseOperate(systemGenerateObject4: SystemGenerateObject4, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).listOperateBaseOperate(systemGenerateObject4, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取操作列表(分页)
     * @param {SystemGenerateObject5} systemGenerateObject5 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public pageOperateBaseOperate(systemGenerateObject5: SystemGenerateObject5, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).pageOperateBaseOperate(systemGenerateObject5, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改操作
     * @param {BaseOperateAdminVo} baseOperateAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOperateApi
     */
    public updateOperateBaseOperate(baseOperateAdminVo: BaseOperateAdminVo, options?: AxiosRequestConfig) {
        return BaseOperateApiFp(this.configuration).updateOperateBaseOperate(baseOperateAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseOrganizationApi - axios parameter creator
 * @export
 */
export const BaseOrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationBaseOrganization: async (baseOrganizationAdminVo: BaseOrganizationAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOrganizationAdminVo' is not null or undefined
            assertParamExists('addOrganizationBaseOrganization', 'baseOrganizationAdminVo', baseOrganizationAdminVo)
            const localVarPath = `/__base/organization/addOrganization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOrganizationAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除组织
         * @param {number} organizationId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOrganizationBaseOrganization: async (organizationId: number, tenantId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('delOrganizationBaseOrganization', 'organizationId', organizationId)
            const localVarPath = `/__base/organization/delOrganization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取组织列表
         * @param {SystemGenerateObject27} systemGenerateObject27 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationsBaseOrganization: async (systemGenerateObject27: SystemGenerateObject27, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject27' is not null or undefined
            assertParamExists('listOrganizationsBaseOrganization', 'systemGenerateObject27', systemGenerateObject27)
            const localVarPath = `/__base/organization/listOrganizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject27, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取组织列表(分页)
         * @param {SystemGenerateObject28} systemGenerateObject28 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationsBaseOrganization: async (systemGenerateObject28: SystemGenerateObject28, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject28' is not null or undefined
            assertParamExists('pageOrganizationsBaseOrganization', 'systemGenerateObject28', systemGenerateObject28)
            const localVarPath = `/__base/organization/pageOrganizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject28, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateOrganizationBaseOrganization: async (baseOrganizationAdminVo: BaseOrganizationAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseOrganizationAdminVo' is not null or undefined
            assertParamExists('udpateOrganizationBaseOrganization', 'baseOrganizationAdminVo', baseOrganizationAdminVo)
            const localVarPath = `/__base/organization/udpateOrganization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseOrganizationAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseOrganizationApi - functional programming interface
 * @export
 */
export const BaseOrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseOrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrganizationBaseOrganization(baseOrganizationAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除组织
         * @param {number} organizationId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delOrganizationBaseOrganization(organizationId: number, tenantId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delOrganizationBaseOrganization(organizationId, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取组织列表
         * @param {SystemGenerateObject27} systemGenerateObject27 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizationsBaseOrganization(systemGenerateObject27: SystemGenerateObject27, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizationsBaseOrganization(systemGenerateObject27, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取组织列表(分页)
         * @param {SystemGenerateObject28} systemGenerateObject28 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOrganizationsBaseOrganization(systemGenerateObject28: SystemGenerateObject28, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOrganizationsBaseOrganization(systemGenerateObject28, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async udpateOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.udpateOrganizationBaseOrganization(baseOrganizationAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseOrganizationApi - factory interface
 * @export
 */
export const BaseOrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseOrganizationApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除组织
         * @param {number} organizationId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delOrganizationBaseOrganization(organizationId: number, tenantId?: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delOrganizationBaseOrganization(organizationId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取组织列表
         * @param {SystemGenerateObject27} systemGenerateObject27 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationsBaseOrganization(systemGenerateObject27: SystemGenerateObject27, options?: any): AxiosPromise<any> {
            return localVarFp.listOrganizationsBaseOrganization(systemGenerateObject27, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取组织列表(分页)
         * @param {SystemGenerateObject28} systemGenerateObject28 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrganizationsBaseOrganization(systemGenerateObject28: SystemGenerateObject28, options?: any): AxiosPromise<any> {
            return localVarFp.pageOrganizationsBaseOrganization(systemGenerateObject28, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改组织
         * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.udpateOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseOrganizationApi - object-oriented interface
 * @export
 * @class BaseOrganizationApi
 * @extends {BaseAPI}
 */
export class BaseOrganizationApi extends BaseAPI {
    /**
     * 
     * @summary 添加组织
     * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public addOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).addOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除组织
     * @param {number} organizationId 
     * @param {number} [tenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public delOrganizationBaseOrganization(organizationId: number, tenantId?: number, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).delOrganizationBaseOrganization(organizationId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取组织列表
     * @param {SystemGenerateObject27} systemGenerateObject27 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public listOrganizationsBaseOrganization(systemGenerateObject27: SystemGenerateObject27, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).listOrganizationsBaseOrganization(systemGenerateObject27, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取组织列表(分页)
     * @param {SystemGenerateObject28} systemGenerateObject28 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public pageOrganizationsBaseOrganization(systemGenerateObject28: SystemGenerateObject28, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).pageOrganizationsBaseOrganization(systemGenerateObject28, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改组织
     * @param {BaseOrganizationAdminVo} baseOrganizationAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseOrganizationApi
     */
    public udpateOrganizationBaseOrganization(baseOrganizationAdminVo: BaseOrganizationAdminVo, options?: AxiosRequestConfig) {
        return BaseOrganizationApiFp(this.configuration).udpateOrganizationBaseOrganization(baseOrganizationAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BasePaymentApi - axios parameter creator
 * @export
 */
export const BasePaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 关闭未支付订单
         * @param {SystemGenerateObject52} systemGenerateObject52 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeOrderBasePayment: async (systemGenerateObject52: SystemGenerateObject52, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject52' is not null or undefined
            assertParamExists('closeOrderBasePayment', 'systemGenerateObject52', systemGenerateObject52)
            const localVarPath = `/__base/payment/closeOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject52, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 创建支付订单
         * @param {SystemGenerateObject50} systemGenerateObject50 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderBasePayment: async (systemGenerateObject50: SystemGenerateObject50, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject50' is not null or undefined
            assertParamExists('createOrderBasePayment', 'systemGenerateObject50', systemGenerateObject50)
            const localVarPath = `/__base/payment/createOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject50, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取订单详情
         * @param {string} orderNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderBasePayment: async (orderNo: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNo' is not null or undefined
            assertParamExists('getOrderBasePayment', 'orderNo', orderNo)
            const localVarPath = `/__base/payment/getOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderNo !== undefined) {
                localVarQueryParameter['orderNo'] = orderNo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 处理支付回调通知
         * @param {SystemGenerateObject56} systemGenerateObject56 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleNotifyBasePayment: async (systemGenerateObject56: SystemGenerateObject56, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject56' is not null or undefined
            assertParamExists('handleNotifyBasePayment', 'systemGenerateObject56', systemGenerateObject56)
            const localVarPath = `/__base/payment/handleNotify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject56, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 处理退款回调通知
         * @param {SystemGenerateObject57} systemGenerateObject57 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleRefundNotifyBasePayment: async (systemGenerateObject57: SystemGenerateObject57, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject57' is not null or undefined
            assertParamExists('handleRefundNotifyBasePayment', 'systemGenerateObject57', systemGenerateObject57)
            const localVarPath = `/__base/payment/handleRefundNotify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject57, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分页查询支付订单
         * @param {SystemGenerateObject53} systemGenerateObject53 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrdersBasePayment: async (systemGenerateObject53: SystemGenerateObject53, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject53' is not null or undefined
            assertParamExists('pageOrdersBasePayment', 'systemGenerateObject53', systemGenerateObject53)
            const localVarPath = `/__base/payment/pageOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject53, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 分页查询退款记录
         * @param {SystemGenerateObject55} systemGenerateObject55 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRefundsBasePayment: async (systemGenerateObject55: SystemGenerateObject55, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject55' is not null or undefined
            assertParamExists('pageRefundsBasePayment', 'systemGenerateObject55', systemGenerateObject55)
            const localVarPath = `/__base/payment/pageRefunds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject55, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发起退款
         * @param {SystemGenerateObject54} systemGenerateObject54 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundBasePayment: async (systemGenerateObject54: SystemGenerateObject54, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject54' is not null or undefined
            assertParamExists('refundBasePayment', 'systemGenerateObject54', systemGenerateObject54)
            const localVarPath = `/__base/payment/refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject54, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 主动查询并同步订单状态
         * @param {SystemGenerateObject51} systemGenerateObject51 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOrderStatusBasePayment: async (systemGenerateObject51: SystemGenerateObject51, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject51' is not null or undefined
            assertParamExists('syncOrderStatusBasePayment', 'systemGenerateObject51', systemGenerateObject51)
            const localVarPath = `/__base/payment/syncOrderStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject51, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BasePaymentApi - functional programming interface
 * @export
 */
export const BasePaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BasePaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 关闭未支付订单
         * @param {SystemGenerateObject52} systemGenerateObject52 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeOrderBasePayment(systemGenerateObject52: SystemGenerateObject52, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeOrderBasePayment(systemGenerateObject52, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 创建支付订单
         * @param {SystemGenerateObject50} systemGenerateObject50 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderBasePayment(systemGenerateObject50: SystemGenerateObject50, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderBasePayment(systemGenerateObject50, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取订单详情
         * @param {string} orderNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderBasePayment(orderNo: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderBasePayment(orderNo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 处理支付回调通知
         * @param {SystemGenerateObject56} systemGenerateObject56 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleNotifyBasePayment(systemGenerateObject56: SystemGenerateObject56, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleNotifyBasePayment(systemGenerateObject56, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 处理退款回调通知
         * @param {SystemGenerateObject57} systemGenerateObject57 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleRefundNotifyBasePayment(systemGenerateObject57: SystemGenerateObject57, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleRefundNotifyBasePayment(systemGenerateObject57, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 分页查询支付订单
         * @param {SystemGenerateObject53} systemGenerateObject53 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageOrdersBasePayment(systemGenerateObject53: SystemGenerateObject53, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageOrdersBasePayment(systemGenerateObject53, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 分页查询退款记录
         * @param {SystemGenerateObject55} systemGenerateObject55 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRefundsBasePayment(systemGenerateObject55: SystemGenerateObject55, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRefundsBasePayment(systemGenerateObject55, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发起退款
         * @param {SystemGenerateObject54} systemGenerateObject54 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundBasePayment(systemGenerateObject54: SystemGenerateObject54, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundBasePayment(systemGenerateObject54, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 主动查询并同步订单状态
         * @param {SystemGenerateObject51} systemGenerateObject51 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncOrderStatusBasePayment(systemGenerateObject51: SystemGenerateObject51, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncOrderStatusBasePayment(systemGenerateObject51, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BasePaymentApi - factory interface
 * @export
 */
export const BasePaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BasePaymentApiFp(configuration)
    return {
        /**
         * 
         * @summary 关闭未支付订单
         * @param {SystemGenerateObject52} systemGenerateObject52 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeOrderBasePayment(systemGenerateObject52: SystemGenerateObject52, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.closeOrderBasePayment(systemGenerateObject52, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 创建支付订单
         * @param {SystemGenerateObject50} systemGenerateObject50 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderBasePayment(systemGenerateObject50: SystemGenerateObject50, options?: any): AxiosPromise<any> {
            return localVarFp.createOrderBasePayment(systemGenerateObject50, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取订单详情
         * @param {string} orderNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderBasePayment(orderNo: string, options?: any): AxiosPromise<any> {
            return localVarFp.getOrderBasePayment(orderNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 处理支付回调通知
         * @param {SystemGenerateObject56} systemGenerateObject56 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleNotifyBasePayment(systemGenerateObject56: SystemGenerateObject56, options?: any): AxiosPromise<any> {
            return localVarFp.handleNotifyBasePayment(systemGenerateObject56, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 处理退款回调通知
         * @param {SystemGenerateObject57} systemGenerateObject57 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleRefundNotifyBasePayment(systemGenerateObject57: SystemGenerateObject57, options?: any): AxiosPromise<any> {
            return localVarFp.handleRefundNotifyBasePayment(systemGenerateObject57, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分页查询支付订单
         * @param {SystemGenerateObject53} systemGenerateObject53 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageOrdersBasePayment(systemGenerateObject53: SystemGenerateObject53, options?: any): AxiosPromise<any> {
            return localVarFp.pageOrdersBasePayment(systemGenerateObject53, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 分页查询退款记录
         * @param {SystemGenerateObject55} systemGenerateObject55 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRefundsBasePayment(systemGenerateObject55: SystemGenerateObject55, options?: any): AxiosPromise<any> {
            return localVarFp.pageRefundsBasePayment(systemGenerateObject55, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发起退款
         * @param {SystemGenerateObject54} systemGenerateObject54 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundBasePayment(systemGenerateObject54: SystemGenerateObject54, options?: any): AxiosPromise<any> {
            return localVarFp.refundBasePayment(systemGenerateObject54, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 主动查询并同步订单状态
         * @param {SystemGenerateObject51} systemGenerateObject51 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncOrderStatusBasePayment(systemGenerateObject51: SystemGenerateObject51, options?: any): AxiosPromise<any> {
            return localVarFp.syncOrderStatusBasePayment(systemGenerateObject51, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BasePaymentApi - object-oriented interface
 * @export
 * @class BasePaymentApi
 * @extends {BaseAPI}
 */
export class BasePaymentApi extends BaseAPI {
    /**
     * 
     * @summary 关闭未支付订单
     * @param {SystemGenerateObject52} systemGenerateObject52 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public closeOrderBasePayment(systemGenerateObject52: SystemGenerateObject52, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).closeOrderBasePayment(systemGenerateObject52, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 创建支付订单
     * @param {SystemGenerateObject50} systemGenerateObject50 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public createOrderBasePayment(systemGenerateObject50: SystemGenerateObject50, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).createOrderBasePayment(systemGenerateObject50, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取订单详情
     * @param {string} orderNo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public getOrderBasePayment(orderNo: string, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).getOrderBasePayment(orderNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 处理支付回调通知
     * @param {SystemGenerateObject56} systemGenerateObject56 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public handleNotifyBasePayment(systemGenerateObject56: SystemGenerateObject56, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).handleNotifyBasePayment(systemGenerateObject56, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 处理退款回调通知
     * @param {SystemGenerateObject57} systemGenerateObject57 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public handleRefundNotifyBasePayment(systemGenerateObject57: SystemGenerateObject57, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).handleRefundNotifyBasePayment(systemGenerateObject57, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分页查询支付订单
     * @param {SystemGenerateObject53} systemGenerateObject53 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public pageOrdersBasePayment(systemGenerateObject53: SystemGenerateObject53, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).pageOrdersBasePayment(systemGenerateObject53, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 分页查询退款记录
     * @param {SystemGenerateObject55} systemGenerateObject55 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public pageRefundsBasePayment(systemGenerateObject55: SystemGenerateObject55, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).pageRefundsBasePayment(systemGenerateObject55, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发起退款
     * @param {SystemGenerateObject54} systemGenerateObject54 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public refundBasePayment(systemGenerateObject54: SystemGenerateObject54, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).refundBasePayment(systemGenerateObject54, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 主动查询并同步订单状态
     * @param {SystemGenerateObject51} systemGenerateObject51 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasePaymentApi
     */
    public syncOrderStatusBasePayment(systemGenerateObject51: SystemGenerateObject51, options?: AxiosRequestConfig) {
        return BasePaymentApiFp(this.configuration).syncOrderStatusBasePayment(systemGenerateObject51, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseRouteApi - axios parameter creator
 * @export
 */
export const BaseRouteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRouteBaseRoute: async (baseRouteAdminVo: BaseRouteAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRouteAdminVo' is not null or undefined
            assertParamExists('addRouteBaseRoute', 'baseRouteAdminVo', baseRouteAdminVo)
            const localVarPath = `/__base/route/addRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRouteAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除路由
         * @param {number} routeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoteBaseRoute: async (routeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'routeId' is not null or undefined
            assertParamExists('deleteRoteBaseRoute', 'routeId', routeId)
            const localVarPath = `/__base/route/deleteRote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (routeId !== undefined) {
                localVarQueryParameter['routeId'] = routeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取无需授权的动态路由
         * @summary 获取无需授权的动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoPermissionRoutesBaseRoute: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/route/getNoPermissionRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取动态路由
         * @summary 获取动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRoutesBaseRoute: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/route/getPermissionRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取路由列表
         * @param {SystemGenerateObject6} systemGenerateObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoutesBaseRoute: async (systemGenerateObject6: SystemGenerateObject6, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject6' is not null or undefined
            assertParamExists('listRoutesBaseRoute', 'systemGenerateObject6', systemGenerateObject6)
            const localVarPath = `/__base/route/listRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject6, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取路由列表(分页)
         * @param {SystemGenerateObject7} systemGenerateObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRoutesBaseRoute: async (systemGenerateObject7: SystemGenerateObject7, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject7' is not null or undefined
            assertParamExists('pageRoutesBaseRoute', 'systemGenerateObject7', systemGenerateObject7)
            const localVarPath = `/__base/route/pageRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject7, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRouteBaseRoute: async (baseRouteAdminVo: BaseRouteAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRouteAdminVo' is not null or undefined
            assertParamExists('updateRouteBaseRoute', 'baseRouteAdminVo', baseRouteAdminVo)
            const localVarPath = `/__base/route/updateRoute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRouteAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseRouteApi - functional programming interface
 * @export
 */
export const BaseRouteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseRouteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRouteBaseRoute(baseRouteAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除路由
         * @param {number} routeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoteBaseRoute(routeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoteBaseRoute(routeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取无需授权的动态路由
         * @summary 获取无需授权的动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNoPermissionRoutesBaseRoute(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNoPermissionRoutesBaseRoute(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取动态路由
         * @summary 获取动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissionRoutesBaseRoute(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissionRoutesBaseRoute(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取路由列表
         * @param {SystemGenerateObject6} systemGenerateObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRoutesBaseRoute(systemGenerateObject6: SystemGenerateObject6, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRoutesBaseRoute(systemGenerateObject6, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取路由列表(分页)
         * @param {SystemGenerateObject7} systemGenerateObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRoutesBaseRoute(systemGenerateObject7: SystemGenerateObject7, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRoutesBaseRoute(systemGenerateObject7, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRouteBaseRoute(baseRouteAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseRouteApi - factory interface
 * @export
 */
export const BaseRouteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseRouteApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除路由
         * @param {number} routeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoteBaseRoute(routeId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteRoteBaseRoute(routeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取无需授权的动态路由
         * @summary 获取无需授权的动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoPermissionRoutesBaseRoute(options?: any): AxiosPromise<any> {
            return localVarFp.getNoPermissionRoutesBaseRoute(options).then((request) => request(axios, basePath));
        },
        /**
         * 获取动态路由
         * @summary 获取动态路由
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionRoutesBaseRoute(options?: any): AxiosPromise<any> {
            return localVarFp.getPermissionRoutesBaseRoute(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取路由列表
         * @param {SystemGenerateObject6} systemGenerateObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoutesBaseRoute(systemGenerateObject6: SystemGenerateObject6, options?: any): AxiosPromise<any> {
            return localVarFp.listRoutesBaseRoute(systemGenerateObject6, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取路由列表(分页)
         * @param {SystemGenerateObject7} systemGenerateObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRoutesBaseRoute(systemGenerateObject7: SystemGenerateObject7, options?: any): AxiosPromise<any> {
            return localVarFp.pageRoutesBaseRoute(systemGenerateObject7, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改路由
         * @param {BaseRouteAdminVo} baseRouteAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseRouteApi - object-oriented interface
 * @export
 * @class BaseRouteApi
 * @extends {BaseAPI}
 */
export class BaseRouteApi extends BaseAPI {
    /**
     * 
     * @summary 添加路由
     * @param {BaseRouteAdminVo} baseRouteAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public addRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).addRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除路由
     * @param {number} routeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public deleteRoteBaseRoute(routeId: number, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).deleteRoteBaseRoute(routeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取无需授权的动态路由
     * @summary 获取无需授权的动态路由
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public getNoPermissionRoutesBaseRoute(options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).getNoPermissionRoutesBaseRoute(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取动态路由
     * @summary 获取动态路由
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public getPermissionRoutesBaseRoute(options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).getPermissionRoutesBaseRoute(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取路由列表
     * @param {SystemGenerateObject6} systemGenerateObject6 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public listRoutesBaseRoute(systemGenerateObject6: SystemGenerateObject6, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).listRoutesBaseRoute(systemGenerateObject6, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取路由列表(分页)
     * @param {SystemGenerateObject7} systemGenerateObject7 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public pageRoutesBaseRoute(systemGenerateObject7: SystemGenerateObject7, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).pageRoutesBaseRoute(systemGenerateObject7, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改路由
     * @param {BaseRouteAdminVo} baseRouteAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseRouteApi
     */
    public updateRouteBaseRoute(baseRouteAdminVo: BaseRouteAdminVo, options?: AxiosRequestConfig) {
        return BaseRouteApiFp(this.configuration).updateRouteBaseRoute(baseRouteAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseScheduleApi - axios parameter creator
 * @export
 */
export const BaseScheduleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 删除任务
         * @param {string} scheduleName 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleBaseSchedule: async (scheduleName: string, tenantId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleName' is not null or undefined
            assertParamExists('deleteScheduleBaseSchedule', 'scheduleName', scheduleName)
            const localVarPath = `/__base/schedule/deleteSchedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (scheduleName !== undefined) {
                localVarQueryParameter['scheduleName'] = scheduleName;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取任务列表(分页)
         * @param {SystemGenerateObject8} systemGenerateObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSchedulesBaseSchedule: async (systemGenerateObject8: SystemGenerateObject8, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject8' is not null or undefined
            assertParamExists('pageSchedulesBaseSchedule', 'systemGenerateObject8', systemGenerateObject8)
            const localVarPath = `/__base/schedule/pageSchedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject8, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseScheduleApi - functional programming interface
 * @export
 */
export const BaseScheduleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseScheduleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 删除任务
         * @param {string} scheduleName 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScheduleBaseSchedule(scheduleName: string, tenantId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScheduleBaseSchedule(scheduleName, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取任务列表(分页)
         * @param {SystemGenerateObject8} systemGenerateObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageSchedulesBaseSchedule(systemGenerateObject8: SystemGenerateObject8, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageSchedulesBaseSchedule(systemGenerateObject8, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseScheduleApi - factory interface
 * @export
 */
export const BaseScheduleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseScheduleApiFp(configuration)
    return {
        /**
         * 
         * @summary 删除任务
         * @param {string} scheduleName 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleBaseSchedule(scheduleName: string, tenantId?: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteScheduleBaseSchedule(scheduleName, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取任务列表(分页)
         * @param {SystemGenerateObject8} systemGenerateObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageSchedulesBaseSchedule(systemGenerateObject8: SystemGenerateObject8, options?: any): AxiosPromise<any> {
            return localVarFp.pageSchedulesBaseSchedule(systemGenerateObject8, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseScheduleApi - object-oriented interface
 * @export
 * @class BaseScheduleApi
 * @extends {BaseAPI}
 */
export class BaseScheduleApi extends BaseAPI {
    /**
     * 
     * @summary 删除任务
     * @param {string} scheduleName 
     * @param {number} [tenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseScheduleApi
     */
    public deleteScheduleBaseSchedule(scheduleName: string, tenantId?: number, options?: AxiosRequestConfig) {
        return BaseScheduleApiFp(this.configuration).deleteScheduleBaseSchedule(scheduleName, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取任务列表(分页)
     * @param {SystemGenerateObject8} systemGenerateObject8 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseScheduleApi
     */
    public pageSchedulesBaseSchedule(systemGenerateObject8: SystemGenerateObject8, options?: AxiosRequestConfig) {
        return BaseScheduleApiFp(this.configuration).pageSchedulesBaseSchedule(systemGenerateObject8, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseTenantApi - axios parameter creator
 * @export
 */
export const BaseTenantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBaseTenantBaseTenant: async (baseTenantAdminVo: BaseTenantAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseTenantAdminVo' is not null or undefined
            assertParamExists('addBaseTenantBaseTenant', 'baseTenantAdminVo', baseTenantAdminVo)
            const localVarPath = `/__base/tenant/addBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseTenantAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除租户
         * @param {number} baseTenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBaseTenantBaseTenant: async (baseTenantId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseTenantId' is not null or undefined
            assertParamExists('delBaseTenantBaseTenant', 'baseTenantId', baseTenantId)
            const localVarPath = `/__base/tenant/delBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (baseTenantId !== undefined) {
                localVarQueryParameter['baseTenantId'] = baseTenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户信息（公共）
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantPublicBaseTenant: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTenantPublicBaseTenant', 'id', id)
            const localVarPath = `/__base/tenant/getTenantPublic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户列表
         * @param {SystemGenerateObject35} systemGenerateObject35 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBaseTenantBaseTenant: async (systemGenerateObject35: SystemGenerateObject35, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject35' is not null or undefined
            assertParamExists('listBaseTenantBaseTenant', 'systemGenerateObject35', systemGenerateObject35)
            const localVarPath = `/__base/tenant/listBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject35, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject36} systemGenerateObject36 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBaseTenantBaseTenant: async (systemGenerateObject36: SystemGenerateObject36, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject36' is not null or undefined
            assertParamExists('pageBaseTenantBaseTenant', 'systemGenerateObject36', systemGenerateObject36)
            const localVarPath = `/__base/tenant/pageBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject36, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBaseTenantBaseTenant: async (baseTenantAdminVo: BaseTenantAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseTenantAdminVo' is not null or undefined
            assertParamExists('updateBaseTenantBaseTenant', 'baseTenantAdminVo', baseTenantAdminVo)
            const localVarPath = `/__base/tenant/updateBaseTenant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseTenantAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseTenantApi - functional programming interface
 * @export
 */
export const BaseTenantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseTenantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBaseTenantBaseTenant(baseTenantAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除租户
         * @param {number} baseTenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delBaseTenantBaseTenant(baseTenantId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delBaseTenantBaseTenant(baseTenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户信息（公共）
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantPublicBaseTenant(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantPublicBaseTenant(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户列表
         * @param {SystemGenerateObject35} systemGenerateObject35 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBaseTenantBaseTenant(systemGenerateObject35: SystemGenerateObject35, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBaseTenantBaseTenant(systemGenerateObject35, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject36} systemGenerateObject36 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageBaseTenantBaseTenant(systemGenerateObject36: SystemGenerateObject36, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageBaseTenantBaseTenant(systemGenerateObject36, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBaseTenantBaseTenant(baseTenantAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseTenantApi - factory interface
 * @export
 */
export const BaseTenantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseTenantApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除租户
         * @param {number} baseTenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delBaseTenantBaseTenant(baseTenantId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delBaseTenantBaseTenant(baseTenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户信息（公共）
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantPublicBaseTenant(id: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.getTenantPublicBaseTenant(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户列表
         * @param {SystemGenerateObject35} systemGenerateObject35 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBaseTenantBaseTenant(systemGenerateObject35: SystemGenerateObject35, options?: any): AxiosPromise<any> {
            return localVarFp.listBaseTenantBaseTenant(systemGenerateObject35, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取租户列表(分页)
         * @param {SystemGenerateObject36} systemGenerateObject36 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageBaseTenantBaseTenant(systemGenerateObject36: SystemGenerateObject36, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.pageBaseTenantBaseTenant(systemGenerateObject36, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新租户
         * @param {BaseTenantAdminVo} baseTenantAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseTenantApi - object-oriented interface
 * @export
 * @class BaseTenantApi
 * @extends {BaseAPI}
 */
export class BaseTenantApi extends BaseAPI {
    /**
     * 
     * @summary 添加租户
     * @param {BaseTenantAdminVo} baseTenantAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public addBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).addBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除租户
     * @param {number} baseTenantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public delBaseTenantBaseTenant(baseTenantId: number, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).delBaseTenantBaseTenant(baseTenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户信息（公共）
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public getTenantPublicBaseTenant(id: number, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).getTenantPublicBaseTenant(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户列表
     * @param {SystemGenerateObject35} systemGenerateObject35 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public listBaseTenantBaseTenant(systemGenerateObject35: SystemGenerateObject35, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).listBaseTenantBaseTenant(systemGenerateObject35, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取租户列表(分页)
     * @param {SystemGenerateObject36} systemGenerateObject36 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public pageBaseTenantBaseTenant(systemGenerateObject36: SystemGenerateObject36, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).pageBaseTenantBaseTenant(systemGenerateObject36, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新租户
     * @param {BaseTenantAdminVo} baseTenantAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseTenantApi
     */
    public updateBaseTenantBaseTenant(baseTenantAdminVo: BaseTenantAdminVo, options?: AxiosRequestConfig) {
        return BaseTenantApiFp(this.configuration).updateBaseTenantBaseTenant(baseTenantAdminVo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseUploadApi - axios parameter creator
 * @export
 */
export const BaseUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 上传文件
         * @summary 上传文件
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesBaseUpload: async (files: Array<File>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('filesBaseUpload', 'files', files)
            const localVarPath = `/__base/upload/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseUploadApi - functional programming interface
 * @export
 */
export const BaseUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 上传文件
         * @summary 上传文件
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesBaseUpload(files: Array<File>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesBaseUpload(files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseUploadApi - factory interface
 * @export
 */
export const BaseUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseUploadApiFp(configuration)
    return {
        /**
         * 上传文件
         * @summary 上传文件
         * @param {Array<File>} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesBaseUpload(files: Array<File>, options?: any): AxiosPromise<any> {
            return localVarFp.filesBaseUpload(files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseUploadApi - object-oriented interface
 * @export
 * @class BaseUploadApi
 * @extends {BaseAPI}
 */
export class BaseUploadApi extends BaseAPI {
    /**
     * 上传文件
     * @summary 上传文件
     * @param {Array<File>} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUploadApi
     */
    public filesBaseUpload(files: Array<File>, options?: AxiosRequestConfig) {
        return BaseUploadApiFp(this.configuration).filesBaseUpload(files, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseUserApi - axios parameter creator
 * @export
 */
export const BaseUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 添加角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleBaseUser: async (baseRoleAdminVo: BaseRoleAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRoleAdminVo' is not null or undefined
            assertParamExists('addRoleBaseUser', 'baseRoleAdminVo', baseRoleAdminVo)
            const localVarPath = `/__base/user/addRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRoleAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserBaseUser: async (baseUserAdminVo: BaseUserAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseUserAdminVo' is not null or undefined
            assertParamExists('addUserBaseUser', 'baseUserAdminVo', baseUserAdminVo)
            const localVarPath = `/__base/user/addUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseUserAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除角色
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRoleBaseUser: async (roleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('delRoleBaseUser', 'roleId', roleId)
            const localVarPath = `/__base/user/delRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除用户
         * @param {number} userId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserBaseUser: async (userId: number, tenantId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserBaseUser', 'userId', userId)
            const localVarPath = `/__base/user/deleteUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 邮箱查重
         * @param {string} email 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByEmailBaseUser: async (email: string, excludeUserId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('existsByEmailBaseUser', 'email', email)
            const localVarPath = `/__base/user/existsByEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (excludeUserId !== undefined) {
                localVarQueryParameter['excludeUserId'] = excludeUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 手机号查重
         * @param {string} phone 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByPhoneBaseUser: async (phone: string, excludeUserId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('existsByPhoneBaseUser', 'phone', phone)
            const localVarPath = `/__base/user/existsByPhone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (excludeUserId !== undefined) {
                localVarQueryParameter['excludeUserId'] = excludeUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 用户名查重
         * @param {string} username 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByUsernameBaseUser: async (username: string, excludeUserId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('existsByUsernameBaseUser', 'username', username)
            const localVarPath = `/__base/user/existsByUsername`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (excludeUserId !== undefined) {
                localVarQueryParameter['excludeUserId'] = excludeUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取用户信息
         * @summary 获取用户信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoBaseUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/user/getUserInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取组织机构下角色列表
         * @param {string} orgCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRolesBaseUser: async (orgCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgCode' is not null or undefined
            assertParamExists('listOrgRolesBaseUser', 'orgCode', orgCode)
            const localVarPath = `/__base/user/listOrgRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgCode !== undefined) {
                localVarQueryParameter['orgCode'] = orgCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取角色列表
         * @param {SystemGenerateObject19} systemGenerateObject19 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRolesBaseUser: async (systemGenerateObject19: SystemGenerateObject19, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject19' is not null or undefined
            assertParamExists('listRolesBaseUser', 'systemGenerateObject19', systemGenerateObject19)
            const localVarPath = `/__base/user/listRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject19, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取系统角色列表
         * @param {SystemGenerateObject17} systemGenerateObject17 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSystemRolesBaseUser: async (systemGenerateObject17: SystemGenerateObject17, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject17' is not null or undefined
            assertParamExists('listSystemRolesBaseUser', 'systemGenerateObject17', systemGenerateObject17)
            const localVarPath = `/__base/user/listSystemRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject17, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取第三方绑定列表
         * @param {SystemGenerateObject16} systemGenerateObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listThirdPartyBaseUser: async (systemGenerateObject16: SystemGenerateObject16, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject16' is not null or undefined
            assertParamExists('listThirdPartyBaseUser', 'systemGenerateObject16', systemGenerateObject16)
            const localVarPath = `/__base/user/listThirdParty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject16, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查询用户的组织角色列表
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserOrgRolesBaseUser: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listUserOrgRolesBaseUser', 'userId', userId)
            const localVarPath = `/__base/user/listUserOrgRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取用户列表
         * @param {SystemGenerateObject21} systemGenerateObject21 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersBaseUser: async (systemGenerateObject21: SystemGenerateObject21, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject21' is not null or undefined
            assertParamExists('listUsersBaseUser', 'systemGenerateObject21', systemGenerateObject21)
            const localVarPath = `/__base/user/listUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject21, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 支持用户名、邮箱、手机号三合一登录
         * @summary 登录(用户名/邮箱/手机号)
         * @param {string} account 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaseUser: async (account: string, password: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'account' is not null or undefined
            assertParamExists('loginBaseUser', 'account', account)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('loginBaseUser', 'password', password)
            const localVarPath = `/__base/user/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (account !== undefined) { 
                localVarFormParams.set('account', account as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 邮箱验证码登录
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByEmailCodeBaseUser: async (email: string, code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('loginByEmailCodeBaseUser', 'email', email)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('loginByEmailCodeBaseUser', 'code', code)
            const localVarPath = `/__base/user/loginByEmailCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
            if (code !== undefined) { 
                localVarFormParams.set('code', code as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 手机号验证码登录
         * @param {string} phone 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByPhoneCodeBaseUser: async (phone: string, code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('loginByPhoneCodeBaseUser', 'phone', phone)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('loginByPhoneCodeBaseUser', 'code', code)
            const localVarPath = `/__base/user/loginByPhoneCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (phone !== undefined) { 
                localVarFormParams.set('phone', phone as any);
            }
    
            if (code !== undefined) { 
                localVarFormParams.set('code', code as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 第三方平台登录
         * @param {string} platform 
         * @param {string} openId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByThirdPartyBaseUser: async (platform: string, openId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platform' is not null or undefined
            assertParamExists('loginByThirdPartyBaseUser', 'platform', platform)
            // verify required parameter 'openId' is not null or undefined
            assertParamExists('loginByThirdPartyBaseUser', 'openId', openId)
            const localVarPath = `/__base/user/loginByThirdParty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (platform !== undefined) { 
                localVarFormParams.set('platform', platform as any);
            }
    
            if (openId !== undefined) { 
                localVarFormParams.set('openId', openId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 登出
         * @summary 登出
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutBaseUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/user/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取角色列表(分页)
         * @param {SystemGenerateObject20} systemGenerateObject20 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRolesBaseUser: async (systemGenerateObject20: SystemGenerateObject20, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject20' is not null or undefined
            assertParamExists('pageRolesBaseUser', 'systemGenerateObject20', systemGenerateObject20)
            const localVarPath = `/__base/user/pageRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject20, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 获取用户列表(分页)
         * @param {SystemGenerateObject22} systemGenerateObject22 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsersBaseUser: async (systemGenerateObject22: SystemGenerateObject22, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject22' is not null or undefined
            assertParamExists('pageUsersBaseUser', 'systemGenerateObject22', systemGenerateObject22)
            const localVarPath = `/__base/user/pageUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject22, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发送邮箱验证码
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailCodeBaseUser: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('sendEmailCodeBaseUser', 'email', email)
            const localVarPath = `/__base/user/sendEmailCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 发送手机验证码
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneCodeBaseUser: async (phone: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('sendPhoneCodeBaseUser', 'phone', phone)
            const localVarPath = `/__base/user/sendPhoneCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (phone !== undefined) { 
                localVarFormParams.set('phone', phone as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateRoleBaseUser: async (baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseRoleAdminVo' is not null or undefined
            assertParamExists('udpateRoleBaseUser', 'baseRoleAdminVo', baseRoleAdminVo)
            const localVarPath = `/__base/user/udpateRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseRoleAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 解绑第三方平台
         * @param {string} platform 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbindThirdPartyBaseUser: async (platform: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platform' is not null or undefined
            assertParamExists('unbindThirdPartyBaseUser', 'platform', platform)
            const localVarPath = `/__base/user/unbindThirdParty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (platform !== undefined) { 
                localVarFormParams.set('platform', platform as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改邮箱(需密码+验证码)
         * @param {SystemGenerateObject25} systemGenerateObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailBaseUser: async (systemGenerateObject25: SystemGenerateObject25, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject25' is not null or undefined
            assertParamExists('updateEmailBaseUser', 'systemGenerateObject25', systemGenerateObject25)
            const localVarPath = `/__base/user/updateEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject25, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改个人信息(仅头像/昵称/meta)
         * @param {SystemGenerateObject26} systemGenerateObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfileBaseUser: async (systemGenerateObject26: SystemGenerateObject26, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject26' is not null or undefined
            assertParamExists('updateMyProfileBaseUser', 'systemGenerateObject26', systemGenerateObject26)
            const localVarPath = `/__base/user/updateMyProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject26, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改手机号(需密码+验证码)
         * @param {SystemGenerateObject24} systemGenerateObject24 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneBaseUser: async (systemGenerateObject24: SystemGenerateObject24, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject24' is not null or undefined
            assertParamExists('updatePhoneBaseUser', 'systemGenerateObject24', systemGenerateObject24)
            const localVarPath = `/__base/user/updatePhone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject24, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserBaseUser: async (baseUserAdminVo: BaseUserAdminVo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseUserAdminVo' is not null or undefined
            assertParamExists('updateUserBaseUser', 'baseUserAdminVo', baseUserAdminVo)
            const localVarPath = `/__base/user/updateUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseUserAdminVo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 更新用户的组织角色列表
         * @param {SystemGenerateObject18} systemGenerateObject18 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrgRolesBaseUser: async (systemGenerateObject18: SystemGenerateObject18, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject18' is not null or undefined
            assertParamExists('updateUserOrgRolesBaseUser', 'systemGenerateObject18', systemGenerateObject18)
            const localVarPath = `/__base/user/updateUserOrgRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject18, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改用户密码
         * @param {SystemGenerateObject23} systemGenerateObject23 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPWBaseUser: async (systemGenerateObject23: SystemGenerateObject23, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject23' is not null or undefined
            assertParamExists('updateUserPWBaseUser', 'systemGenerateObject23', systemGenerateObject23)
            const localVarPath = `/__base/user/updateUserPW`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject23, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseUserApi - functional programming interface
 * @export
 */
export const BaseUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 添加角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRoleBaseUser(baseRoleAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserBaseUser(baseUserAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除角色
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delRoleBaseUser(roleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delRoleBaseUser(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除用户
         * @param {number} userId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserBaseUser(userId: number, tenantId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserBaseUser(userId, tenantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 邮箱查重
         * @param {string} email 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsByEmailBaseUser(email: string, excludeUserId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsByEmailBaseUser(email, excludeUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 手机号查重
         * @param {string} phone 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsByPhoneBaseUser(phone: string, excludeUserId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsByPhoneBaseUser(phone, excludeUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 用户名查重
         * @param {string} username 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsByUsernameBaseUser(username: string, excludeUserId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsByUsernameBaseUser(username, excludeUserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取用户信息
         * @summary 获取用户信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfoBaseUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfoBaseUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取组织机构下角色列表
         * @param {string} orgCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrgRolesBaseUser(orgCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrgRolesBaseUser(orgCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取角色列表
         * @param {SystemGenerateObject19} systemGenerateObject19 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRolesBaseUser(systemGenerateObject19: SystemGenerateObject19, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRolesBaseUser(systemGenerateObject19, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取系统角色列表
         * @param {SystemGenerateObject17} systemGenerateObject17 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSystemRolesBaseUser(systemGenerateObject17: SystemGenerateObject17, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSystemRolesBaseUser(systemGenerateObject17, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取第三方绑定列表
         * @param {SystemGenerateObject16} systemGenerateObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listThirdPartyBaseUser(systemGenerateObject16: SystemGenerateObject16, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listThirdPartyBaseUser(systemGenerateObject16, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查询用户的组织角色列表
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserOrgRolesBaseUser(userId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserOrgRolesBaseUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取用户列表
         * @param {SystemGenerateObject21} systemGenerateObject21 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsersBaseUser(systemGenerateObject21: SystemGenerateObject21, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersBaseUser(systemGenerateObject21, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 支持用户名、邮箱、手机号三合一登录
         * @summary 登录(用户名/邮箱/手机号)
         * @param {string} account 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginBaseUser(account: string, password: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginBaseUser(account, password, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 邮箱验证码登录
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginByEmailCodeBaseUser(email: string, code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginByEmailCodeBaseUser(email, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 手机号验证码登录
         * @param {string} phone 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginByPhoneCodeBaseUser(phone: string, code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginByPhoneCodeBaseUser(phone, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 第三方平台登录
         * @param {string} platform 
         * @param {string} openId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginByThirdPartyBaseUser(platform: string, openId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginByThirdPartyBaseUser(platform, openId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 登出
         * @summary 登出
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutBaseUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logoutBaseUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取角色列表(分页)
         * @param {SystemGenerateObject20} systemGenerateObject20 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageRolesBaseUser(systemGenerateObject20: SystemGenerateObject20, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageRolesBaseUser(systemGenerateObject20, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 获取用户列表(分页)
         * @param {SystemGenerateObject22} systemGenerateObject22 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pageUsersBaseUser(systemGenerateObject22: SystemGenerateObject22, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pageUsersBaseUser(systemGenerateObject22, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发送邮箱验证码
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailCodeBaseUser(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailCodeBaseUser(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 发送手机验证码
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPhoneCodeBaseUser(phone: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPhoneCodeBaseUser(phone, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async udpateRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.udpateRoleBaseUser(baseRoleAdminVo, force, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 解绑第三方平台
         * @param {string} platform 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unbindThirdPartyBaseUser(platform: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unbindThirdPartyBaseUser(platform, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改邮箱(需密码+验证码)
         * @param {SystemGenerateObject25} systemGenerateObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailBaseUser(systemGenerateObject25: SystemGenerateObject25, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailBaseUser(systemGenerateObject25, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改个人信息(仅头像/昵称/meta)
         * @param {SystemGenerateObject26} systemGenerateObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyProfileBaseUser(systemGenerateObject26: SystemGenerateObject26, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyProfileBaseUser(systemGenerateObject26, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改手机号(需密码+验证码)
         * @param {SystemGenerateObject24} systemGenerateObject24 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhoneBaseUser(systemGenerateObject24: SystemGenerateObject24, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhoneBaseUser(systemGenerateObject24, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserBaseUser(baseUserAdminVo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 更新用户的组织角色列表
         * @param {SystemGenerateObject18} systemGenerateObject18 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserOrgRolesBaseUser(systemGenerateObject18: SystemGenerateObject18, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserOrgRolesBaseUser(systemGenerateObject18, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改用户密码
         * @param {SystemGenerateObject23} systemGenerateObject23 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPWBaseUser(systemGenerateObject23: SystemGenerateObject23, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPWBaseUser(systemGenerateObject23, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseUserApi - factory interface
 * @export
 */
export const BaseUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseUserApiFp(configuration)
    return {
        /**
         * 
         * @summary 添加角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addRoleBaseUser(baseRoleAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.addUserBaseUser(baseUserAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除角色
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delRoleBaseUser(roleId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.delRoleBaseUser(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除用户
         * @param {number} userId 
         * @param {number} [tenantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserBaseUser(userId: number, tenantId?: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.deleteUserBaseUser(userId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 邮箱查重
         * @param {string} email 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByEmailBaseUser(email: string, excludeUserId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.existsByEmailBaseUser(email, excludeUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 手机号查重
         * @param {string} phone 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByPhoneBaseUser(phone: string, excludeUserId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.existsByPhoneBaseUser(phone, excludeUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 用户名查重
         * @param {string} username 
         * @param {number} [excludeUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByUsernameBaseUser(username: string, excludeUserId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.existsByUsernameBaseUser(username, excludeUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取用户信息
         * @summary 获取用户信息
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoBaseUser(options?: any): AxiosPromise<any> {
            return localVarFp.getUserInfoBaseUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取组织机构下角色列表
         * @param {string} orgCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrgRolesBaseUser(orgCode: string, options?: any): AxiosPromise<any> {
            return localVarFp.listOrgRolesBaseUser(orgCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取角色列表
         * @param {SystemGenerateObject19} systemGenerateObject19 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRolesBaseUser(systemGenerateObject19: SystemGenerateObject19, options?: any): AxiosPromise<any> {
            return localVarFp.listRolesBaseUser(systemGenerateObject19, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取系统角色列表
         * @param {SystemGenerateObject17} systemGenerateObject17 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSystemRolesBaseUser(systemGenerateObject17: SystemGenerateObject17, options?: any): AxiosPromise<any> {
            return localVarFp.listSystemRolesBaseUser(systemGenerateObject17, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取第三方绑定列表
         * @param {SystemGenerateObject16} systemGenerateObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listThirdPartyBaseUser(systemGenerateObject16: SystemGenerateObject16, options?: any): AxiosPromise<any> {
            return localVarFp.listThirdPartyBaseUser(systemGenerateObject16, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查询用户的组织角色列表
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserOrgRolesBaseUser(userId: number, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.listUserOrgRolesBaseUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取用户列表
         * @param {SystemGenerateObject21} systemGenerateObject21 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersBaseUser(systemGenerateObject21: SystemGenerateObject21, options?: any): AxiosPromise<any> {
            return localVarFp.listUsersBaseUser(systemGenerateObject21, options).then((request) => request(axios, basePath));
        },
        /**
         * 支持用户名、邮箱、手机号三合一登录
         * @summary 登录(用户名/邮箱/手机号)
         * @param {string} account 
         * @param {string} password 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginBaseUser(account: string, password: string, options?: any): AxiosPromise<any> {
            return localVarFp.loginBaseUser(account, password, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 邮箱验证码登录
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByEmailCodeBaseUser(email: string, code: string, options?: any): AxiosPromise<any> {
            return localVarFp.loginByEmailCodeBaseUser(email, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 手机号验证码登录
         * @param {string} phone 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByPhoneCodeBaseUser(phone: string, code: string, options?: any): AxiosPromise<any> {
            return localVarFp.loginByPhoneCodeBaseUser(phone, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 第三方平台登录
         * @param {string} platform 
         * @param {string} openId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginByThirdPartyBaseUser(platform: string, openId: string, options?: any): AxiosPromise<any> {
            return localVarFp.loginByThirdPartyBaseUser(platform, openId, options).then((request) => request(axios, basePath));
        },
        /**
         * 登出
         * @summary 登出
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutBaseUser(options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.logoutBaseUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取角色列表(分页)
         * @param {SystemGenerateObject20} systemGenerateObject20 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageRolesBaseUser(systemGenerateObject20: SystemGenerateObject20, options?: any): AxiosPromise<any> {
            return localVarFp.pageRolesBaseUser(systemGenerateObject20, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 获取用户列表(分页)
         * @param {SystemGenerateObject22} systemGenerateObject22 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsersBaseUser(systemGenerateObject22: SystemGenerateObject22, options?: any): AxiosPromise<any> {
            return localVarFp.pageUsersBaseUser(systemGenerateObject22, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发送邮箱验证码
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailCodeBaseUser(email: string, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.sendEmailCodeBaseUser(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 发送手机验证码
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneCodeBaseUser(phone: string, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.sendPhoneCodeBaseUser(phone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改角色
         * @param {BaseRoleAdminVo} baseRoleAdminVo 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        udpateRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.udpateRoleBaseUser(baseRoleAdminVo, force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 解绑第三方平台
         * @param {string} platform 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbindThirdPartyBaseUser(platform: string, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.unbindThirdPartyBaseUser(platform, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改邮箱(需密码+验证码)
         * @param {SystemGenerateObject25} systemGenerateObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailBaseUser(systemGenerateObject25: SystemGenerateObject25, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateEmailBaseUser(systemGenerateObject25, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改个人信息(仅头像/昵称/meta)
         * @param {SystemGenerateObject26} systemGenerateObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyProfileBaseUser(systemGenerateObject26: SystemGenerateObject26, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateMyProfileBaseUser(systemGenerateObject26, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改手机号(需密码+验证码)
         * @param {SystemGenerateObject24} systemGenerateObject24 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneBaseUser(systemGenerateObject24: SystemGenerateObject24, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updatePhoneBaseUser(systemGenerateObject24, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改用户
         * @param {BaseUserAdminVo} baseUserAdminVo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateUserBaseUser(baseUserAdminVo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 更新用户的组织角色列表
         * @param {SystemGenerateObject18} systemGenerateObject18 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOrgRolesBaseUser(systemGenerateObject18: SystemGenerateObject18, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateUserOrgRolesBaseUser(systemGenerateObject18, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改用户密码
         * @param {SystemGenerateObject23} systemGenerateObject23 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPWBaseUser(systemGenerateObject23: SystemGenerateObject23, options?: any): AxiosPromise<BaseResultVo> {
            return localVarFp.updateUserPWBaseUser(systemGenerateObject23, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseUserApi - object-oriented interface
 * @export
 * @class BaseUserApi
 * @extends {BaseAPI}
 */
export class BaseUserApi extends BaseAPI {
    /**
     * 
     * @summary 添加角色
     * @param {BaseRoleAdminVo} baseRoleAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public addRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).addRoleBaseUser(baseRoleAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加用户
     * @param {BaseUserAdminVo} baseUserAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public addUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).addUserBaseUser(baseUserAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除角色
     * @param {number} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public delRoleBaseUser(roleId: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).delRoleBaseUser(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除用户
     * @param {number} userId 
     * @param {number} [tenantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public deleteUserBaseUser(userId: number, tenantId?: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).deleteUserBaseUser(userId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 邮箱查重
     * @param {string} email 
     * @param {number} [excludeUserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public existsByEmailBaseUser(email: string, excludeUserId?: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).existsByEmailBaseUser(email, excludeUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 手机号查重
     * @param {string} phone 
     * @param {number} [excludeUserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public existsByPhoneBaseUser(phone: string, excludeUserId?: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).existsByPhoneBaseUser(phone, excludeUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 用户名查重
     * @param {string} username 
     * @param {number} [excludeUserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public existsByUsernameBaseUser(username: string, excludeUserId?: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).existsByUsernameBaseUser(username, excludeUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取用户信息
     * @summary 获取用户信息
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public getUserInfoBaseUser(options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).getUserInfoBaseUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取组织机构下角色列表
     * @param {string} orgCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listOrgRolesBaseUser(orgCode: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listOrgRolesBaseUser(orgCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取角色列表
     * @param {SystemGenerateObject19} systemGenerateObject19 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listRolesBaseUser(systemGenerateObject19: SystemGenerateObject19, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listRolesBaseUser(systemGenerateObject19, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取系统角色列表
     * @param {SystemGenerateObject17} systemGenerateObject17 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listSystemRolesBaseUser(systemGenerateObject17: SystemGenerateObject17, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listSystemRolesBaseUser(systemGenerateObject17, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取第三方绑定列表
     * @param {SystemGenerateObject16} systemGenerateObject16 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listThirdPartyBaseUser(systemGenerateObject16: SystemGenerateObject16, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listThirdPartyBaseUser(systemGenerateObject16, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查询用户的组织角色列表
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listUserOrgRolesBaseUser(userId: number, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listUserOrgRolesBaseUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取用户列表
     * @param {SystemGenerateObject21} systemGenerateObject21 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public listUsersBaseUser(systemGenerateObject21: SystemGenerateObject21, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).listUsersBaseUser(systemGenerateObject21, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 支持用户名、邮箱、手机号三合一登录
     * @summary 登录(用户名/邮箱/手机号)
     * @param {string} account 
     * @param {string} password 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public loginBaseUser(account: string, password: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).loginBaseUser(account, password, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 邮箱验证码登录
     * @param {string} email 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public loginByEmailCodeBaseUser(email: string, code: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).loginByEmailCodeBaseUser(email, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 手机号验证码登录
     * @param {string} phone 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public loginByPhoneCodeBaseUser(phone: string, code: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).loginByPhoneCodeBaseUser(phone, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 第三方平台登录
     * @param {string} platform 
     * @param {string} openId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public loginByThirdPartyBaseUser(platform: string, openId: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).loginByThirdPartyBaseUser(platform, openId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 登出
     * @summary 登出
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public logoutBaseUser(options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).logoutBaseUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取角色列表(分页)
     * @param {SystemGenerateObject20} systemGenerateObject20 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public pageRolesBaseUser(systemGenerateObject20: SystemGenerateObject20, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).pageRolesBaseUser(systemGenerateObject20, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 获取用户列表(分页)
     * @param {SystemGenerateObject22} systemGenerateObject22 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public pageUsersBaseUser(systemGenerateObject22: SystemGenerateObject22, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).pageUsersBaseUser(systemGenerateObject22, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发送邮箱验证码
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public sendEmailCodeBaseUser(email: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).sendEmailCodeBaseUser(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 发送手机验证码
     * @param {string} phone 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public sendPhoneCodeBaseUser(phone: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).sendPhoneCodeBaseUser(phone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改角色
     * @param {BaseRoleAdminVo} baseRoleAdminVo 
     * @param {boolean} [force] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public udpateRoleBaseUser(baseRoleAdminVo: BaseRoleAdminVo, force?: boolean, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).udpateRoleBaseUser(baseRoleAdminVo, force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 解绑第三方平台
     * @param {string} platform 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public unbindThirdPartyBaseUser(platform: string, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).unbindThirdPartyBaseUser(platform, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改邮箱(需密码+验证码)
     * @param {SystemGenerateObject25} systemGenerateObject25 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateEmailBaseUser(systemGenerateObject25: SystemGenerateObject25, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateEmailBaseUser(systemGenerateObject25, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改个人信息(仅头像/昵称/meta)
     * @param {SystemGenerateObject26} systemGenerateObject26 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateMyProfileBaseUser(systemGenerateObject26: SystemGenerateObject26, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateMyProfileBaseUser(systemGenerateObject26, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改手机号(需密码+验证码)
     * @param {SystemGenerateObject24} systemGenerateObject24 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updatePhoneBaseUser(systemGenerateObject24: SystemGenerateObject24, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updatePhoneBaseUser(systemGenerateObject24, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改用户
     * @param {BaseUserAdminVo} baseUserAdminVo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateUserBaseUser(baseUserAdminVo: BaseUserAdminVo, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateUserBaseUser(baseUserAdminVo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 更新用户的组织角色列表
     * @param {SystemGenerateObject18} systemGenerateObject18 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateUserOrgRolesBaseUser(systemGenerateObject18: SystemGenerateObject18, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateUserOrgRolesBaseUser(systemGenerateObject18, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改用户密码
     * @param {SystemGenerateObject23} systemGenerateObject23 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUserApi
     */
    public updateUserPWBaseUser(systemGenerateObject23: SystemGenerateObject23, options?: AxiosRequestConfig) {
        return BaseUserApiFp(this.configuration).updateUserPWBaseUser(systemGenerateObject23, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BaseUtilApi - axios parameter creator
 * @export
 */
export const BaseUtilApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 获取id
         * @summary 获取id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdBaseUtil: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/util/getId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取id
         * @summary 获取ids
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdsBaseUtil: async (count: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'count' is not null or undefined
            assertParamExists('getIdsBaseUtil', 'count', count)
            const localVarPath = `/__base/util/getIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 获取uuid
         * @summary 获取uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUUIDBaseUtil: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/__base/util/getUUID`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseUtilApi - functional programming interface
 * @export
 */
export const BaseUtilApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseUtilApiAxiosParamCreator(configuration)
    return {
        /**
         * 获取id
         * @summary 获取id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdBaseUtil(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdBaseUtil(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取id
         * @summary 获取ids
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIdsBaseUtil(count: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIdsBaseUtil(count, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 获取uuid
         * @summary 获取uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUUIDBaseUtil(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUUIDBaseUtil(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseUtilApi - factory interface
 * @export
 */
export const BaseUtilApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseUtilApiFp(configuration)
    return {
        /**
         * 获取id
         * @summary 获取id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdBaseUtil(options?: any): AxiosPromise<number> {
            return localVarFp.getIdBaseUtil(options).then((request) => request(axios, basePath));
        },
        /**
         * 获取id
         * @summary 获取ids
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdsBaseUtil(count: number, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.getIdsBaseUtil(count, options).then((request) => request(axios, basePath));
        },
        /**
         * 获取uuid
         * @summary 获取uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUUIDBaseUtil(options?: any): AxiosPromise<string> {
            return localVarFp.getUUIDBaseUtil(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseUtilApi - object-oriented interface
 * @export
 * @class BaseUtilApi
 * @extends {BaseAPI}
 */
export class BaseUtilApi extends BaseAPI {
    /**
     * 获取id
     * @summary 获取id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUtilApi
     */
    public getIdBaseUtil(options?: AxiosRequestConfig) {
        return BaseUtilApiFp(this.configuration).getIdBaseUtil(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取id
     * @summary 获取ids
     * @param {number} count 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUtilApi
     */
    public getIdsBaseUtil(count: number, options?: AxiosRequestConfig) {
        return BaseUtilApiFp(this.configuration).getIdsBaseUtil(count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 获取uuid
     * @summary 获取uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseUtilApi
     */
    public getUUIDBaseUtil(options?: AxiosRequestConfig) {
        return BaseUtilApiFp(this.configuration).getUUIDBaseUtil(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SearchTrackAdminApi - axios parameter creator
 * @export
 */
export const SearchTrackAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 后台新增绑定账号
         * @param {SystemGenerateObject74} systemGenerateObject74 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAddSearchTrackAdmin: async (systemGenerateObject74: SystemGenerateObject74, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject74' is not null or undefined
            assertParamExists('accountAddSearchTrackAdmin', 'systemGenerateObject74', systemGenerateObject74)
            const localVarPath = `/search-track/admin/account/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject74, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台删除绑定账号
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountDeleteSearchTrackAdmin: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accountDeleteSearchTrackAdmin', 'id', id)
            const localVarPath = `/search-track/admin/account/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台绑定账号分页
         * @param {string} [keyword] 
         * @param {number} [stationId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountPageSearchTrackAdmin: async (keyword?: string, stationId?: number, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/admin/account/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台修改绑定账号
         * @param {SystemGenerateObject75} systemGenerateObject75 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdateSearchTrackAdmin: async (systemGenerateObject75: SystemGenerateObject75, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject75' is not null or undefined
            assertParamExists('accountUpdateSearchTrackAdmin', 'systemGenerateObject75', systemGenerateObject75)
            const localVarPath = `/search-track/admin/account/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject75, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 协议列表（服务协议 / 隐私条款）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementListSearchTrackAdmin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/admin/agreement/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 保存协议（内容变化则版本号 +1）
         * @param {SystemGenerateObject82} systemGenerateObject82 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementSaveSearchTrackAdmin: async (systemGenerateObject82: SystemGenerateObject82, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject82' is not null or undefined
            assertParamExists('agreementSaveSearchTrackAdmin', 'systemGenerateObject82', systemGenerateObject82)
            const localVarPath = `/search-track/admin/agreement/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject82, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台批量删除二维码
         * @param {SystemGenerateObject81} systemGenerateObject81 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeBatchDeleteSearchTrackAdmin: async (systemGenerateObject81: SystemGenerateObject81, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject81' is not null or undefined
            assertParamExists('qrcodeBatchDeleteSearchTrackAdmin', 'systemGenerateObject81', systemGenerateObject81)
            const localVarPath = `/search-track/admin/qrcode/batchDelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject81, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台批量生成二维码（明文URL Scheme）
         * @param {SystemGenerateObject76} systemGenerateObject76 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeBatchGenerateSearchTrackAdmin: async (systemGenerateObject76: SystemGenerateObject76, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject76' is not null or undefined
            assertParamExists('qrcodeBatchGenerateSearchTrackAdmin', 'systemGenerateObject76', systemGenerateObject76)
            const localVarPath = `/search-track/admin/qrcode/batchGenerate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject76, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台按二维码链接（明文 URL Scheme）绑定到驿站
         * @param {SystemGenerateObject79} systemGenerateObject79 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeBindSchemeSearchTrackAdmin: async (systemGenerateObject79: SystemGenerateObject79, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject79' is not null or undefined
            assertParamExists('qrcodeBindSchemeSearchTrackAdmin', 'systemGenerateObject79', systemGenerateObject79)
            const localVarPath = `/search-track/admin/qrcode/bindScheme`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject79, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台删除二维码
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeDeleteSearchTrackAdmin: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('qrcodeDeleteSearchTrackAdmin', 'id', id)
            const localVarPath = `/search-track/admin/qrcode/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台导出二维码（zip）
         * @param {string} [keyword] 
         * @param {string} [remark] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeExportSearchTrackAdmin: async (keyword?: string, remark?: string, stationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/admin/qrcode/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (remark !== undefined) {
                localVarQueryParameter['remark'] = remark;
            }

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台生成单枚二维码
         * @param {SystemGenerateObject77} systemGenerateObject77 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeGenerateSearchTrackAdmin: async (systemGenerateObject77: SystemGenerateObject77, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject77' is not null or undefined
            assertParamExists('qrcodeGenerateSearchTrackAdmin', 'systemGenerateObject77', systemGenerateObject77)
            const localVarPath = `/search-track/admin/qrcode/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject77, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台二维码列表
         * @param {string} [keyword] 
         * @param {string} [remark] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeListSearchTrackAdmin: async (keyword?: string, remark?: string, stationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/admin/qrcode/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (remark !== undefined) {
                localVarQueryParameter['remark'] = remark;
            }

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台二维码分页
         * @param {string} [keyword] 
         * @param {string} [remark] 
         * @param {number} [stationId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodePageSearchTrackAdmin: async (keyword?: string, remark?: string, stationId?: number, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/admin/qrcode/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (remark !== undefined) {
                localVarQueryParameter['remark'] = remark;
            }

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台重新生成 NFC 链接（支持批量）
         * @param {SystemGenerateObject80} systemGenerateObject80 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeRefreshNfcSearchTrackAdmin: async (systemGenerateObject80: SystemGenerateObject80, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject80' is not null or undefined
            assertParamExists('qrcodeRefreshNfcSearchTrackAdmin', 'systemGenerateObject80', systemGenerateObject80)
            const localVarPath = `/search-track/admin/qrcode/refreshNfc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject80, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台重新生成二维码链接
         * @param {SystemGenerateObject78} systemGenerateObject78 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeRefreshSearchTrackAdmin: async (systemGenerateObject78: SystemGenerateObject78, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject78' is not null or undefined
            assertParamExists('qrcodeRefreshSearchTrackAdmin', 'systemGenerateObject78', systemGenerateObject78)
            const localVarPath = `/search-track/admin/qrcode/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject78, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台新增驿站
         * @param {SystemGenerateObject72} systemGenerateObject72 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationAddSearchTrackAdmin: async (systemGenerateObject72: SystemGenerateObject72, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject72' is not null or undefined
            assertParamExists('stationAddSearchTrackAdmin', 'systemGenerateObject72', systemGenerateObject72)
            const localVarPath = `/search-track/admin/station/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject72, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台删除驿站
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationDeleteSearchTrackAdmin: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stationDeleteSearchTrackAdmin', 'id', id)
            const localVarPath = `/search-track/admin/station/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台驿站全量列表（下拉选择用）
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationListSearchTrackAdmin: async (keyword?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/admin/station/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台驿站分页
         * @param {string} [keyword] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationPageSearchTrackAdmin: async (keyword?: string, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/admin/station/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台修改驿站
         * @param {SystemGenerateObject73} systemGenerateObject73 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationUpdateSearchTrackAdmin: async (systemGenerateObject73: SystemGenerateObject73, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject73' is not null or undefined
            assertParamExists('stationUpdateSearchTrackAdmin', 'systemGenerateObject73', systemGenerateObject73)
            const localVarPath = `/search-track/admin/station/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject73, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台数据概览
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarySearchTrackAdmin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/admin/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 后台小程序用户分页
         * @param {string} [keyword] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPageSearchTrackAdmin: async (keyword?: string, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/admin/user/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchTrackAdminApi - functional programming interface
 * @export
 */
export const SearchTrackAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchTrackAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 后台新增绑定账号
         * @param {SystemGenerateObject74} systemGenerateObject74 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountAddSearchTrackAdmin(systemGenerateObject74: SystemGenerateObject74, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountAddSearchTrackAdmin(systemGenerateObject74, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台删除绑定账号
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountDeleteSearchTrackAdmin(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountDeleteSearchTrackAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台绑定账号分页
         * @param {string} [keyword] 
         * @param {number} [stationId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountPageSearchTrackAdmin(keyword?: string, stationId?: number, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountPageSearchTrackAdmin(keyword, stationId, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台修改绑定账号
         * @param {SystemGenerateObject75} systemGenerateObject75 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountUpdateSearchTrackAdmin(systemGenerateObject75: SystemGenerateObject75, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountUpdateSearchTrackAdmin(systemGenerateObject75, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 协议列表（服务协议 / 隐私条款）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreementListSearchTrackAdmin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreementListSearchTrackAdmin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 保存协议（内容变化则版本号 +1）
         * @param {SystemGenerateObject82} systemGenerateObject82 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreementSaveSearchTrackAdmin(systemGenerateObject82: SystemGenerateObject82, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreementSaveSearchTrackAdmin(systemGenerateObject82, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台批量删除二维码
         * @param {SystemGenerateObject81} systemGenerateObject81 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodeBatchDeleteSearchTrackAdmin(systemGenerateObject81: SystemGenerateObject81, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodeBatchDeleteSearchTrackAdmin(systemGenerateObject81, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台批量生成二维码（明文URL Scheme）
         * @param {SystemGenerateObject76} systemGenerateObject76 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodeBatchGenerateSearchTrackAdmin(systemGenerateObject76: SystemGenerateObject76, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodeBatchGenerateSearchTrackAdmin(systemGenerateObject76, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台按二维码链接（明文 URL Scheme）绑定到驿站
         * @param {SystemGenerateObject79} systemGenerateObject79 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodeBindSchemeSearchTrackAdmin(systemGenerateObject79: SystemGenerateObject79, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodeBindSchemeSearchTrackAdmin(systemGenerateObject79, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台删除二维码
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodeDeleteSearchTrackAdmin(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodeDeleteSearchTrackAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台导出二维码（zip）
         * @param {string} [keyword] 
         * @param {string} [remark] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodeExportSearchTrackAdmin(keyword?: string, remark?: string, stationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodeExportSearchTrackAdmin(keyword, remark, stationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台生成单枚二维码
         * @param {SystemGenerateObject77} systemGenerateObject77 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodeGenerateSearchTrackAdmin(systemGenerateObject77: SystemGenerateObject77, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodeGenerateSearchTrackAdmin(systemGenerateObject77, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台二维码列表
         * @param {string} [keyword] 
         * @param {string} [remark] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodeListSearchTrackAdmin(keyword?: string, remark?: string, stationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodeListSearchTrackAdmin(keyword, remark, stationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台二维码分页
         * @param {string} [keyword] 
         * @param {string} [remark] 
         * @param {number} [stationId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodePageSearchTrackAdmin(keyword?: string, remark?: string, stationId?: number, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodePageSearchTrackAdmin(keyword, remark, stationId, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台重新生成 NFC 链接（支持批量）
         * @param {SystemGenerateObject80} systemGenerateObject80 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodeRefreshNfcSearchTrackAdmin(systemGenerateObject80: SystemGenerateObject80, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodeRefreshNfcSearchTrackAdmin(systemGenerateObject80, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台重新生成二维码链接
         * @param {SystemGenerateObject78} systemGenerateObject78 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodeRefreshSearchTrackAdmin(systemGenerateObject78: SystemGenerateObject78, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodeRefreshSearchTrackAdmin(systemGenerateObject78, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台新增驿站
         * @param {SystemGenerateObject72} systemGenerateObject72 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stationAddSearchTrackAdmin(systemGenerateObject72: SystemGenerateObject72, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stationAddSearchTrackAdmin(systemGenerateObject72, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台删除驿站
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stationDeleteSearchTrackAdmin(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stationDeleteSearchTrackAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台驿站全量列表（下拉选择用）
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stationListSearchTrackAdmin(keyword?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stationListSearchTrackAdmin(keyword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台驿站分页
         * @param {string} [keyword] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stationPageSearchTrackAdmin(keyword?: string, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stationPageSearchTrackAdmin(keyword, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台修改驿站
         * @param {SystemGenerateObject73} systemGenerateObject73 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stationUpdateSearchTrackAdmin(systemGenerateObject73: SystemGenerateObject73, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stationUpdateSearchTrackAdmin(systemGenerateObject73, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台数据概览
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summarySearchTrackAdmin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summarySearchTrackAdmin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 后台小程序用户分页
         * @param {string} [keyword] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPageSearchTrackAdmin(keyword?: string, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPageSearchTrackAdmin(keyword, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchTrackAdminApi - factory interface
 * @export
 */
export const SearchTrackAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchTrackAdminApiFp(configuration)
    return {
        /**
         * 
         * @summary 后台新增绑定账号
         * @param {SystemGenerateObject74} systemGenerateObject74 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountAddSearchTrackAdmin(systemGenerateObject74: SystemGenerateObject74, options?: any): AxiosPromise<any> {
            return localVarFp.accountAddSearchTrackAdmin(systemGenerateObject74, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台删除绑定账号
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountDeleteSearchTrackAdmin(id: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.accountDeleteSearchTrackAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台绑定账号分页
         * @param {string} [keyword] 
         * @param {number} [stationId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountPageSearchTrackAdmin(keyword?: string, stationId?: number, page?: number, pageSize?: number, options?: any): AxiosPromise<any> {
            return localVarFp.accountPageSearchTrackAdmin(keyword, stationId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台修改绑定账号
         * @param {SystemGenerateObject75} systemGenerateObject75 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdateSearchTrackAdmin(systemGenerateObject75: SystemGenerateObject75, options?: any): AxiosPromise<any> {
            return localVarFp.accountUpdateSearchTrackAdmin(systemGenerateObject75, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 协议列表（服务协议 / 隐私条款）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementListSearchTrackAdmin(options?: any): AxiosPromise<any> {
            return localVarFp.agreementListSearchTrackAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 保存协议（内容变化则版本号 +1）
         * @param {SystemGenerateObject82} systemGenerateObject82 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementSaveSearchTrackAdmin(systemGenerateObject82: SystemGenerateObject82, options?: any): AxiosPromise<any> {
            return localVarFp.agreementSaveSearchTrackAdmin(systemGenerateObject82, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台批量删除二维码
         * @param {SystemGenerateObject81} systemGenerateObject81 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeBatchDeleteSearchTrackAdmin(systemGenerateObject81: SystemGenerateObject81, options?: any): AxiosPromise<any> {
            return localVarFp.qrcodeBatchDeleteSearchTrackAdmin(systemGenerateObject81, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台批量生成二维码（明文URL Scheme）
         * @param {SystemGenerateObject76} systemGenerateObject76 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeBatchGenerateSearchTrackAdmin(systemGenerateObject76: SystemGenerateObject76, options?: any): AxiosPromise<any> {
            return localVarFp.qrcodeBatchGenerateSearchTrackAdmin(systemGenerateObject76, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台按二维码链接（明文 URL Scheme）绑定到驿站
         * @param {SystemGenerateObject79} systemGenerateObject79 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeBindSchemeSearchTrackAdmin(systemGenerateObject79: SystemGenerateObject79, options?: any): AxiosPromise<any> {
            return localVarFp.qrcodeBindSchemeSearchTrackAdmin(systemGenerateObject79, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台删除二维码
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeDeleteSearchTrackAdmin(id: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.qrcodeDeleteSearchTrackAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台导出二维码（zip）
         * @param {string} [keyword] 
         * @param {string} [remark] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeExportSearchTrackAdmin(keyword?: string, remark?: string, stationId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.qrcodeExportSearchTrackAdmin(keyword, remark, stationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台生成单枚二维码
         * @param {SystemGenerateObject77} systemGenerateObject77 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeGenerateSearchTrackAdmin(systemGenerateObject77: SystemGenerateObject77, options?: any): AxiosPromise<any> {
            return localVarFp.qrcodeGenerateSearchTrackAdmin(systemGenerateObject77, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台二维码列表
         * @param {string} [keyword] 
         * @param {string} [remark] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeListSearchTrackAdmin(keyword?: string, remark?: string, stationId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.qrcodeListSearchTrackAdmin(keyword, remark, stationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台二维码分页
         * @param {string} [keyword] 
         * @param {string} [remark] 
         * @param {number} [stationId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodePageSearchTrackAdmin(keyword?: string, remark?: string, stationId?: number, page?: number, pageSize?: number, options?: any): AxiosPromise<any> {
            return localVarFp.qrcodePageSearchTrackAdmin(keyword, remark, stationId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台重新生成 NFC 链接（支持批量）
         * @param {SystemGenerateObject80} systemGenerateObject80 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeRefreshNfcSearchTrackAdmin(systemGenerateObject80: SystemGenerateObject80, options?: any): AxiosPromise<any> {
            return localVarFp.qrcodeRefreshNfcSearchTrackAdmin(systemGenerateObject80, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台重新生成二维码链接
         * @param {SystemGenerateObject78} systemGenerateObject78 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodeRefreshSearchTrackAdmin(systemGenerateObject78: SystemGenerateObject78, options?: any): AxiosPromise<any> {
            return localVarFp.qrcodeRefreshSearchTrackAdmin(systemGenerateObject78, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台新增驿站
         * @param {SystemGenerateObject72} systemGenerateObject72 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationAddSearchTrackAdmin(systemGenerateObject72: SystemGenerateObject72, options?: any): AxiosPromise<any> {
            return localVarFp.stationAddSearchTrackAdmin(systemGenerateObject72, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台删除驿站
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationDeleteSearchTrackAdmin(id: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.stationDeleteSearchTrackAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台驿站全量列表（下拉选择用）
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationListSearchTrackAdmin(keyword?: string, options?: any): AxiosPromise<any> {
            return localVarFp.stationListSearchTrackAdmin(keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台驿站分页
         * @param {string} [keyword] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationPageSearchTrackAdmin(keyword?: string, page?: number, pageSize?: number, options?: any): AxiosPromise<any> {
            return localVarFp.stationPageSearchTrackAdmin(keyword, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台修改驿站
         * @param {SystemGenerateObject73} systemGenerateObject73 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationUpdateSearchTrackAdmin(systemGenerateObject73: SystemGenerateObject73, options?: any): AxiosPromise<any> {
            return localVarFp.stationUpdateSearchTrackAdmin(systemGenerateObject73, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台数据概览
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarySearchTrackAdmin(options?: any): AxiosPromise<any> {
            return localVarFp.summarySearchTrackAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 后台小程序用户分页
         * @param {string} [keyword] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPageSearchTrackAdmin(keyword?: string, page?: number, pageSize?: number, options?: any): AxiosPromise<any> {
            return localVarFp.userPageSearchTrackAdmin(keyword, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchTrackAdminApi - object-oriented interface
 * @export
 * @class SearchTrackAdminApi
 * @extends {BaseAPI}
 */
export class SearchTrackAdminApi extends BaseAPI {
    /**
     * 
     * @summary 后台新增绑定账号
     * @param {SystemGenerateObject74} systemGenerateObject74 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public accountAddSearchTrackAdmin(systemGenerateObject74: SystemGenerateObject74, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).accountAddSearchTrackAdmin(systemGenerateObject74, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台删除绑定账号
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public accountDeleteSearchTrackAdmin(id: number, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).accountDeleteSearchTrackAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台绑定账号分页
     * @param {string} [keyword] 
     * @param {number} [stationId] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public accountPageSearchTrackAdmin(keyword?: string, stationId?: number, page?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).accountPageSearchTrackAdmin(keyword, stationId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台修改绑定账号
     * @param {SystemGenerateObject75} systemGenerateObject75 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public accountUpdateSearchTrackAdmin(systemGenerateObject75: SystemGenerateObject75, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).accountUpdateSearchTrackAdmin(systemGenerateObject75, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 协议列表（服务协议 / 隐私条款）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public agreementListSearchTrackAdmin(options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).agreementListSearchTrackAdmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 保存协议（内容变化则版本号 +1）
     * @param {SystemGenerateObject82} systemGenerateObject82 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public agreementSaveSearchTrackAdmin(systemGenerateObject82: SystemGenerateObject82, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).agreementSaveSearchTrackAdmin(systemGenerateObject82, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台批量删除二维码
     * @param {SystemGenerateObject81} systemGenerateObject81 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public qrcodeBatchDeleteSearchTrackAdmin(systemGenerateObject81: SystemGenerateObject81, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).qrcodeBatchDeleteSearchTrackAdmin(systemGenerateObject81, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台批量生成二维码（明文URL Scheme）
     * @param {SystemGenerateObject76} systemGenerateObject76 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public qrcodeBatchGenerateSearchTrackAdmin(systemGenerateObject76: SystemGenerateObject76, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).qrcodeBatchGenerateSearchTrackAdmin(systemGenerateObject76, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台按二维码链接（明文 URL Scheme）绑定到驿站
     * @param {SystemGenerateObject79} systemGenerateObject79 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public qrcodeBindSchemeSearchTrackAdmin(systemGenerateObject79: SystemGenerateObject79, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).qrcodeBindSchemeSearchTrackAdmin(systemGenerateObject79, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台删除二维码
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public qrcodeDeleteSearchTrackAdmin(id: number, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).qrcodeDeleteSearchTrackAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台导出二维码（zip）
     * @param {string} [keyword] 
     * @param {string} [remark] 
     * @param {number} [stationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public qrcodeExportSearchTrackAdmin(keyword?: string, remark?: string, stationId?: number, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).qrcodeExportSearchTrackAdmin(keyword, remark, stationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台生成单枚二维码
     * @param {SystemGenerateObject77} systemGenerateObject77 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public qrcodeGenerateSearchTrackAdmin(systemGenerateObject77: SystemGenerateObject77, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).qrcodeGenerateSearchTrackAdmin(systemGenerateObject77, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台二维码列表
     * @param {string} [keyword] 
     * @param {string} [remark] 
     * @param {number} [stationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public qrcodeListSearchTrackAdmin(keyword?: string, remark?: string, stationId?: number, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).qrcodeListSearchTrackAdmin(keyword, remark, stationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台二维码分页
     * @param {string} [keyword] 
     * @param {string} [remark] 
     * @param {number} [stationId] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public qrcodePageSearchTrackAdmin(keyword?: string, remark?: string, stationId?: number, page?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).qrcodePageSearchTrackAdmin(keyword, remark, stationId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台重新生成 NFC 链接（支持批量）
     * @param {SystemGenerateObject80} systemGenerateObject80 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public qrcodeRefreshNfcSearchTrackAdmin(systemGenerateObject80: SystemGenerateObject80, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).qrcodeRefreshNfcSearchTrackAdmin(systemGenerateObject80, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台重新生成二维码链接
     * @param {SystemGenerateObject78} systemGenerateObject78 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public qrcodeRefreshSearchTrackAdmin(systemGenerateObject78: SystemGenerateObject78, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).qrcodeRefreshSearchTrackAdmin(systemGenerateObject78, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台新增驿站
     * @param {SystemGenerateObject72} systemGenerateObject72 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public stationAddSearchTrackAdmin(systemGenerateObject72: SystemGenerateObject72, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).stationAddSearchTrackAdmin(systemGenerateObject72, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台删除驿站
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public stationDeleteSearchTrackAdmin(id: number, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).stationDeleteSearchTrackAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台驿站全量列表（下拉选择用）
     * @param {string} [keyword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public stationListSearchTrackAdmin(keyword?: string, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).stationListSearchTrackAdmin(keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台驿站分页
     * @param {string} [keyword] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public stationPageSearchTrackAdmin(keyword?: string, page?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).stationPageSearchTrackAdmin(keyword, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台修改驿站
     * @param {SystemGenerateObject73} systemGenerateObject73 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public stationUpdateSearchTrackAdmin(systemGenerateObject73: SystemGenerateObject73, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).stationUpdateSearchTrackAdmin(systemGenerateObject73, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台数据概览
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public summarySearchTrackAdmin(options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).summarySearchTrackAdmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 后台小程序用户分页
     * @param {string} [keyword] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackAdminApi
     */
    public userPageSearchTrackAdmin(keyword?: string, page?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return SearchTrackAdminApiFp(this.configuration).userPageSearchTrackAdmin(keyword, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SearchTrackWeappApi - axios parameter creator
 * @export
 */
export const SearchTrackWeappApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 绑定账号列表
         * @param {string} [openid] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsSearchTrackWeapp: async (openid?: string, stationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/weapp/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (openid !== undefined) {
                localVarQueryParameter['openid'] = openid;
            }

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 绑定平台账号（落库后立即登录+试查校验）
         * @param {SystemGenerateObject64} systemGenerateObject64 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAccountSearchTrackWeapp: async (systemGenerateObject64: SystemGenerateObject64, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject64' is not null or undefined
            assertParamExists('addAccountSearchTrackWeapp', 'systemGenerateObject64', systemGenerateObject64)
            const localVarPath = `/search-track/weapp/account/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject64, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 添加驿站
         * @param {SystemGenerateObject62} systemGenerateObject62 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStationSearchTrackWeapp: async (systemGenerateObject62: SystemGenerateObject62, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject62' is not null or undefined
            assertParamExists('addStationSearchTrackWeapp', 'systemGenerateObject62', systemGenerateObject62)
            const localVarPath = `/search-track/weapp/station/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject62, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 服务协议 / 隐私条款（只返回已发布内容）
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementSearchTrackWeapp: async (type: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('agreementSearchTrackWeapp', 'type', type)
            const localVarPath = `/search-track/weapp/agreement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 绑定二维码到驿站
         * @param {SystemGenerateObject66} systemGenerateObject66 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindQrcodeSearchTrackWeapp: async (systemGenerateObject66: SystemGenerateObject66, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject66' is not null or undefined
            assertParamExists('bindQrcodeSearchTrackWeapp', 'systemGenerateObject66', systemGenerateObject66)
            const localVarPath = `/search-track/weapp/qrcode/bind`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject66, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 取消绑定（放弃验证码弹窗时清理半成品账号）
         * @param {SystemGenerateObject71} systemGenerateObject71 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBindSearchTrackWeapp: async (systemGenerateObject71: SystemGenerateObject71, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject71' is not null or undefined
            assertParamExists('cancelBindSearchTrackWeapp', 'systemGenerateObject71', systemGenerateObject71)
            const localVarPath = `/search-track/weapp/account/cancel-bind`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject71, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除绑定账号
         * @param {number} id 
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSearchTrackWeapp: async (id: number, openid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAccountSearchTrackWeapp', 'id', id)
            const localVarPath = `/search-track/weapp/account/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (openid !== undefined) {
                localVarQueryParameter['openid'] = openid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除二维码
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQrcodeSearchTrackWeapp: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteQrcodeSearchTrackWeapp', 'id', id)
            const localVarPath = `/search-track/weapp/qrcode/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 删除驿站
         * @param {number} id 
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStationSearchTrackWeapp: async (id: number, openid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteStationSearchTrackWeapp', 'id', id)
            const localVarPath = `/search-track/weapp/station/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (openid !== undefined) {
                localVarQueryParameter['openid'] = openid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 下载驿站二维码
         * @param {number} stationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadQrcodeSearchTrackWeapp: async (stationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stationId' is not null or undefined
            assertParamExists('downloadQrcodeSearchTrackWeapp', 'stationId', stationId)
            const localVarPath = `/search-track/weapp/qrcode/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 生成驿站二维码（明文URL Scheme）
         * @param {SystemGenerateObject67} systemGenerateObject67 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateQrcodeSearchTrackWeapp: async (systemGenerateObject67: SystemGenerateObject67, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject67' is not null or undefined
            assertParamExists('generateQrcodeSearchTrackWeapp', 'systemGenerateObject67', systemGenerateObject67)
            const localVarPath = `/search-track/weapp/qrcode/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject67, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 小程序登录（openid 即用户ID）
         * @param {SystemGenerateObject59} systemGenerateObject59 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSearchTrackWeapp: async (systemGenerateObject59: SystemGenerateObject59, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject59' is not null or undefined
            assertParamExists('loginSearchTrackWeapp', 'systemGenerateObject59', systemGenerateObject59)
            const localVarPath = `/search-track/weapp/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject59, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查件（转发第三方查询接口，后端不落库）
         * @param {SystemGenerateObject68} systemGenerateObject68 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelQuerySearchTrackWeapp: async (systemGenerateObject68: SystemGenerateObject68, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject68' is not null or undefined
            assertParamExists('parcelQuerySearchTrackWeapp', 'systemGenerateObject68', systemGenerateObject68)
            const localVarPath = `/search-track/weapp/parcel/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject68, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 菜鸟账号授权：第 1 步登录 + 第 2 步发送验证码
         * @param {SystemGenerateObject69} systemGenerateObject69 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelSessionSendCodeSearchTrackWeapp: async (systemGenerateObject69: SystemGenerateObject69, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject69' is not null or undefined
            assertParamExists('parcelSessionSendCodeSearchTrackWeapp', 'systemGenerateObject69', systemGenerateObject69)
            const localVarPath = `/search-track/weapp/parcel/session/send-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject69, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 平台会话状态（菜鸟是否需要重新授权）
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelSessionStatusSearchTrackWeapp: async (stationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/weapp/parcel/session/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 菜鸟账号授权：第 3 步验证验证码换取会话
         * @param {SystemGenerateObject70} systemGenerateObject70 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelSessionSubmitCodeSearchTrackWeapp: async (systemGenerateObject70: SystemGenerateObject70, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject70' is not null or undefined
            assertParamExists('parcelSessionSubmitCodeSearchTrackWeapp', 'systemGenerateObject70', systemGenerateObject70)
            const localVarPath = `/search-track/weapp/parcel/session/submit-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject70, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 我的信息
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileSearchTrackWeapp: async (openid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/weapp/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (openid !== undefined) {
                localVarQueryParameter['openid'] = openid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 驿站二维码列表
         * @param {string} [openid] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodesSearchTrackWeapp: async (openid?: string, stationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/weapp/qrcodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (openid !== undefined) {
                localVarQueryParameter['openid'] = openid;
            }

            if (stationId !== undefined) {
                localVarQueryParameter['stationId'] = stationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 查询历史（首页输入框下拉，最多 10 条）
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryHistorySearchTrackWeapp: async (openid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/weapp/query-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (openid !== undefined) {
                localVarQueryParameter['openid'] = openid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 扫码进入（解析二维码ID）
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanSearchTrackWeapp: async (code?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/weapp/scan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 我的驿站列表
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsSearchTrackWeapp: async (openid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/weapp/stations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (openid !== undefined) {
                localVarQueryParameter['openid'] = openid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 我的数据概览
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarySearchTrackWeapp: async (openid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search-track/weapp/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (openid !== undefined) {
                localVarQueryParameter['openid'] = openid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改绑定账号
         * @param {SystemGenerateObject65} systemGenerateObject65 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountSearchTrackWeapp: async (systemGenerateObject65: SystemGenerateObject65, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject65' is not null or undefined
            assertParamExists('updateAccountSearchTrackWeapp', 'systemGenerateObject65', systemGenerateObject65)
            const localVarPath = `/search-track/weapp/account/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject65, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改个人资料（头像 / 昵称）
         * @param {SystemGenerateObject60} systemGenerateObject60 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileSearchTrackWeapp: async (systemGenerateObject60: SystemGenerateObject60, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject60' is not null or undefined
            assertParamExists('updateProfileSearchTrackWeapp', 'systemGenerateObject60', systemGenerateObject60)
            const localVarPath = `/search-track/weapp/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject60, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 修改驿站
         * @param {SystemGenerateObject63} systemGenerateObject63 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStationSearchTrackWeapp: async (systemGenerateObject63: SystemGenerateObject63, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemGenerateObject63' is not null or undefined
            assertParamExists('updateStationSearchTrackWeapp', 'systemGenerateObject63', systemGenerateObject63)
            const localVarPath = `/search-track/weapp/station/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemGenerateObject63, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 微信 chooseAvatar / H5 文件选择器拿到的本地图片，落到 public/upload/avatar 下
         * @summary 上传头像
         * @param {File} file 
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAvatarSearchTrackWeapp: async (file: File, openid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadAvatarSearchTrackWeapp', 'file', file)
            const localVarPath = `/search-track/weapp/profile/avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (openid !== undefined) {
                localVarQueryParameter['openid'] = openid;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchTrackWeappApi - functional programming interface
 * @export
 */
export const SearchTrackWeappApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchTrackWeappApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 绑定账号列表
         * @param {string} [openid] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountsSearchTrackWeapp(openid?: string, stationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountsSearchTrackWeapp(openid, stationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 绑定平台账号（落库后立即登录+试查校验）
         * @param {SystemGenerateObject64} systemGenerateObject64 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAccountSearchTrackWeapp(systemGenerateObject64: SystemGenerateObject64, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAccountSearchTrackWeapp(systemGenerateObject64, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 添加驿站
         * @param {SystemGenerateObject62} systemGenerateObject62 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStationSearchTrackWeapp(systemGenerateObject62: SystemGenerateObject62, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStationSearchTrackWeapp(systemGenerateObject62, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 服务协议 / 隐私条款（只返回已发布内容）
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreementSearchTrackWeapp(type: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreementSearchTrackWeapp(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 绑定二维码到驿站
         * @param {SystemGenerateObject66} systemGenerateObject66 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bindQrcodeSearchTrackWeapp(systemGenerateObject66: SystemGenerateObject66, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bindQrcodeSearchTrackWeapp(systemGenerateObject66, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 取消绑定（放弃验证码弹窗时清理半成品账号）
         * @param {SystemGenerateObject71} systemGenerateObject71 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelBindSearchTrackWeapp(systemGenerateObject71: SystemGenerateObject71, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelBindSearchTrackWeapp(systemGenerateObject71, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除绑定账号
         * @param {number} id 
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccountSearchTrackWeapp(id: number, openid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccountSearchTrackWeapp(id, openid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除二维码
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQrcodeSearchTrackWeapp(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQrcodeSearchTrackWeapp(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 删除驿站
         * @param {number} id 
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStationSearchTrackWeapp(id: number, openid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultVo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStationSearchTrackWeapp(id, openid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 下载驿站二维码
         * @param {number} stationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadQrcodeSearchTrackWeapp(stationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadQrcodeSearchTrackWeapp(stationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 生成驿站二维码（明文URL Scheme）
         * @param {SystemGenerateObject67} systemGenerateObject67 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateQrcodeSearchTrackWeapp(systemGenerateObject67: SystemGenerateObject67, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateQrcodeSearchTrackWeapp(systemGenerateObject67, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 小程序登录（openid 即用户ID）
         * @param {SystemGenerateObject59} systemGenerateObject59 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginSearchTrackWeapp(systemGenerateObject59: SystemGenerateObject59, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginSearchTrackWeapp(systemGenerateObject59, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查件（转发第三方查询接口，后端不落库）
         * @param {SystemGenerateObject68} systemGenerateObject68 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parcelQuerySearchTrackWeapp(systemGenerateObject68: SystemGenerateObject68, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parcelQuerySearchTrackWeapp(systemGenerateObject68, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 菜鸟账号授权：第 1 步登录 + 第 2 步发送验证码
         * @param {SystemGenerateObject69} systemGenerateObject69 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parcelSessionSendCodeSearchTrackWeapp(systemGenerateObject69: SystemGenerateObject69, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parcelSessionSendCodeSearchTrackWeapp(systemGenerateObject69, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 平台会话状态（菜鸟是否需要重新授权）
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parcelSessionStatusSearchTrackWeapp(stationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parcelSessionStatusSearchTrackWeapp(stationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 菜鸟账号授权：第 3 步验证验证码换取会话
         * @param {SystemGenerateObject70} systemGenerateObject70 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parcelSessionSubmitCodeSearchTrackWeapp(systemGenerateObject70: SystemGenerateObject70, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parcelSessionSubmitCodeSearchTrackWeapp(systemGenerateObject70, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 我的信息
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileSearchTrackWeapp(openid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileSearchTrackWeapp(openid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 驿站二维码列表
         * @param {string} [openid] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async qrcodesSearchTrackWeapp(openid?: string, stationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrcodesSearchTrackWeapp(openid, stationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 查询历史（首页输入框下拉，最多 10 条）
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryHistorySearchTrackWeapp(openid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryHistorySearchTrackWeapp(openid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 扫码进入（解析二维码ID）
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scanSearchTrackWeapp(code?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scanSearchTrackWeapp(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 我的驿站列表
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stationsSearchTrackWeapp(openid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stationsSearchTrackWeapp(openid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 我的数据概览
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summarySearchTrackWeapp(openid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summarySearchTrackWeapp(openid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改绑定账号
         * @param {SystemGenerateObject65} systemGenerateObject65 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountSearchTrackWeapp(systemGenerateObject65: SystemGenerateObject65, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountSearchTrackWeapp(systemGenerateObject65, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改个人资料（头像 / 昵称）
         * @param {SystemGenerateObject60} systemGenerateObject60 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfileSearchTrackWeapp(systemGenerateObject60: SystemGenerateObject60, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfileSearchTrackWeapp(systemGenerateObject60, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 修改驿站
         * @param {SystemGenerateObject63} systemGenerateObject63 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStationSearchTrackWeapp(systemGenerateObject63: SystemGenerateObject63, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStationSearchTrackWeapp(systemGenerateObject63, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 微信 chooseAvatar / H5 文件选择器拿到的本地图片，落到 public/upload/avatar 下
         * @summary 上传头像
         * @param {File} file 
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAvatarSearchTrackWeapp(file: File, openid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAvatarSearchTrackWeapp(file, openid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchTrackWeappApi - factory interface
 * @export
 */
export const SearchTrackWeappApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchTrackWeappApiFp(configuration)
    return {
        /**
         * 
         * @summary 绑定账号列表
         * @param {string} [openid] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsSearchTrackWeapp(openid?: string, stationId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.accountsSearchTrackWeapp(openid, stationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 绑定平台账号（落库后立即登录+试查校验）
         * @param {SystemGenerateObject64} systemGenerateObject64 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAccountSearchTrackWeapp(systemGenerateObject64: SystemGenerateObject64, options?: any): AxiosPromise<any> {
            return localVarFp.addAccountSearchTrackWeapp(systemGenerateObject64, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 添加驿站
         * @param {SystemGenerateObject62} systemGenerateObject62 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStationSearchTrackWeapp(systemGenerateObject62: SystemGenerateObject62, options?: any): AxiosPromise<any> {
            return localVarFp.addStationSearchTrackWeapp(systemGenerateObject62, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 服务协议 / 隐私条款（只返回已发布内容）
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementSearchTrackWeapp(type: string, options?: any): AxiosPromise<any> {
            return localVarFp.agreementSearchTrackWeapp(type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 绑定二维码到驿站
         * @param {SystemGenerateObject66} systemGenerateObject66 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bindQrcodeSearchTrackWeapp(systemGenerateObject66: SystemGenerateObject66, options?: any): AxiosPromise<any> {
            return localVarFp.bindQrcodeSearchTrackWeapp(systemGenerateObject66, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 取消绑定（放弃验证码弹窗时清理半成品账号）
         * @param {SystemGenerateObject71} systemGenerateObject71 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBindSearchTrackWeapp(systemGenerateObject71: SystemGenerateObject71, options?: any): AxiosPromise<any> {
            return localVarFp.cancelBindSearchTrackWeapp(systemGenerateObject71, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除绑定账号
         * @param {number} id 
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountSearchTrackWeapp(id: number, openid?: string, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deleteAccountSearchTrackWeapp(id, openid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除二维码
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQrcodeSearchTrackWeapp(id: number, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deleteQrcodeSearchTrackWeapp(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 删除驿站
         * @param {number} id 
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStationSearchTrackWeapp(id: number, openid?: string, options?: any): AxiosPromise<ResultVo> {
            return localVarFp.deleteStationSearchTrackWeapp(id, openid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 下载驿站二维码
         * @param {number} stationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadQrcodeSearchTrackWeapp(stationId: number, options?: any): AxiosPromise<any> {
            return localVarFp.downloadQrcodeSearchTrackWeapp(stationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 生成驿站二维码（明文URL Scheme）
         * @param {SystemGenerateObject67} systemGenerateObject67 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateQrcodeSearchTrackWeapp(systemGenerateObject67: SystemGenerateObject67, options?: any): AxiosPromise<any> {
            return localVarFp.generateQrcodeSearchTrackWeapp(systemGenerateObject67, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 小程序登录（openid 即用户ID）
         * @param {SystemGenerateObject59} systemGenerateObject59 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSearchTrackWeapp(systemGenerateObject59: SystemGenerateObject59, options?: any): AxiosPromise<any> {
            return localVarFp.loginSearchTrackWeapp(systemGenerateObject59, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查件（转发第三方查询接口，后端不落库）
         * @param {SystemGenerateObject68} systemGenerateObject68 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelQuerySearchTrackWeapp(systemGenerateObject68: SystemGenerateObject68, options?: any): AxiosPromise<any> {
            return localVarFp.parcelQuerySearchTrackWeapp(systemGenerateObject68, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 菜鸟账号授权：第 1 步登录 + 第 2 步发送验证码
         * @param {SystemGenerateObject69} systemGenerateObject69 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelSessionSendCodeSearchTrackWeapp(systemGenerateObject69: SystemGenerateObject69, options?: any): AxiosPromise<any> {
            return localVarFp.parcelSessionSendCodeSearchTrackWeapp(systemGenerateObject69, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 平台会话状态（菜鸟是否需要重新授权）
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelSessionStatusSearchTrackWeapp(stationId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.parcelSessionStatusSearchTrackWeapp(stationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 菜鸟账号授权：第 3 步验证验证码换取会话
         * @param {SystemGenerateObject70} systemGenerateObject70 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelSessionSubmitCodeSearchTrackWeapp(systemGenerateObject70: SystemGenerateObject70, options?: any): AxiosPromise<any> {
            return localVarFp.parcelSessionSubmitCodeSearchTrackWeapp(systemGenerateObject70, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 我的信息
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileSearchTrackWeapp(openid?: string, options?: any): AxiosPromise<any> {
            return localVarFp.profileSearchTrackWeapp(openid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 驿站二维码列表
         * @param {string} [openid] 
         * @param {number} [stationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        qrcodesSearchTrackWeapp(openid?: string, stationId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.qrcodesSearchTrackWeapp(openid, stationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 查询历史（首页输入框下拉，最多 10 条）
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryHistorySearchTrackWeapp(openid?: string, options?: any): AxiosPromise<any> {
            return localVarFp.queryHistorySearchTrackWeapp(openid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 扫码进入（解析二维码ID）
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanSearchTrackWeapp(code?: string, options?: any): AxiosPromise<any> {
            return localVarFp.scanSearchTrackWeapp(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 我的驿站列表
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stationsSearchTrackWeapp(openid?: string, options?: any): AxiosPromise<any> {
            return localVarFp.stationsSearchTrackWeapp(openid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 我的数据概览
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarySearchTrackWeapp(openid?: string, options?: any): AxiosPromise<any> {
            return localVarFp.summarySearchTrackWeapp(openid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改绑定账号
         * @param {SystemGenerateObject65} systemGenerateObject65 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountSearchTrackWeapp(systemGenerateObject65: SystemGenerateObject65, options?: any): AxiosPromise<any> {
            return localVarFp.updateAccountSearchTrackWeapp(systemGenerateObject65, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改个人资料（头像 / 昵称）
         * @param {SystemGenerateObject60} systemGenerateObject60 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileSearchTrackWeapp(systemGenerateObject60: SystemGenerateObject60, options?: any): AxiosPromise<any> {
            return localVarFp.updateProfileSearchTrackWeapp(systemGenerateObject60, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 修改驿站
         * @param {SystemGenerateObject63} systemGenerateObject63 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStationSearchTrackWeapp(systemGenerateObject63: SystemGenerateObject63, options?: any): AxiosPromise<any> {
            return localVarFp.updateStationSearchTrackWeapp(systemGenerateObject63, options).then((request) => request(axios, basePath));
        },
        /**
         * 微信 chooseAvatar / H5 文件选择器拿到的本地图片，落到 public/upload/avatar 下
         * @summary 上传头像
         * @param {File} file 
         * @param {string} [openid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAvatarSearchTrackWeapp(file: File, openid?: string, options?: any): AxiosPromise<any> {
            return localVarFp.uploadAvatarSearchTrackWeapp(file, openid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchTrackWeappApi - object-oriented interface
 * @export
 * @class SearchTrackWeappApi
 * @extends {BaseAPI}
 */
export class SearchTrackWeappApi extends BaseAPI {
    /**
     * 
     * @summary 绑定账号列表
     * @param {string} [openid] 
     * @param {number} [stationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public accountsSearchTrackWeapp(openid?: string, stationId?: number, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).accountsSearchTrackWeapp(openid, stationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 绑定平台账号（落库后立即登录+试查校验）
     * @param {SystemGenerateObject64} systemGenerateObject64 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public addAccountSearchTrackWeapp(systemGenerateObject64: SystemGenerateObject64, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).addAccountSearchTrackWeapp(systemGenerateObject64, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 添加驿站
     * @param {SystemGenerateObject62} systemGenerateObject62 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public addStationSearchTrackWeapp(systemGenerateObject62: SystemGenerateObject62, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).addStationSearchTrackWeapp(systemGenerateObject62, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 服务协议 / 隐私条款（只返回已发布内容）
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public agreementSearchTrackWeapp(type: string, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).agreementSearchTrackWeapp(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 绑定二维码到驿站
     * @param {SystemGenerateObject66} systemGenerateObject66 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public bindQrcodeSearchTrackWeapp(systemGenerateObject66: SystemGenerateObject66, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).bindQrcodeSearchTrackWeapp(systemGenerateObject66, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 取消绑定（放弃验证码弹窗时清理半成品账号）
     * @param {SystemGenerateObject71} systemGenerateObject71 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public cancelBindSearchTrackWeapp(systemGenerateObject71: SystemGenerateObject71, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).cancelBindSearchTrackWeapp(systemGenerateObject71, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除绑定账号
     * @param {number} id 
     * @param {string} [openid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public deleteAccountSearchTrackWeapp(id: number, openid?: string, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).deleteAccountSearchTrackWeapp(id, openid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除二维码
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public deleteQrcodeSearchTrackWeapp(id: number, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).deleteQrcodeSearchTrackWeapp(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 删除驿站
     * @param {number} id 
     * @param {string} [openid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public deleteStationSearchTrackWeapp(id: number, openid?: string, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).deleteStationSearchTrackWeapp(id, openid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 下载驿站二维码
     * @param {number} stationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public downloadQrcodeSearchTrackWeapp(stationId: number, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).downloadQrcodeSearchTrackWeapp(stationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 生成驿站二维码（明文URL Scheme）
     * @param {SystemGenerateObject67} systemGenerateObject67 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public generateQrcodeSearchTrackWeapp(systemGenerateObject67: SystemGenerateObject67, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).generateQrcodeSearchTrackWeapp(systemGenerateObject67, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 小程序登录（openid 即用户ID）
     * @param {SystemGenerateObject59} systemGenerateObject59 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public loginSearchTrackWeapp(systemGenerateObject59: SystemGenerateObject59, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).loginSearchTrackWeapp(systemGenerateObject59, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查件（转发第三方查询接口，后端不落库）
     * @param {SystemGenerateObject68} systemGenerateObject68 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public parcelQuerySearchTrackWeapp(systemGenerateObject68: SystemGenerateObject68, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).parcelQuerySearchTrackWeapp(systemGenerateObject68, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 菜鸟账号授权：第 1 步登录 + 第 2 步发送验证码
     * @param {SystemGenerateObject69} systemGenerateObject69 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public parcelSessionSendCodeSearchTrackWeapp(systemGenerateObject69: SystemGenerateObject69, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).parcelSessionSendCodeSearchTrackWeapp(systemGenerateObject69, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 平台会话状态（菜鸟是否需要重新授权）
     * @param {number} [stationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public parcelSessionStatusSearchTrackWeapp(stationId?: number, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).parcelSessionStatusSearchTrackWeapp(stationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 菜鸟账号授权：第 3 步验证验证码换取会话
     * @param {SystemGenerateObject70} systemGenerateObject70 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public parcelSessionSubmitCodeSearchTrackWeapp(systemGenerateObject70: SystemGenerateObject70, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).parcelSessionSubmitCodeSearchTrackWeapp(systemGenerateObject70, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 我的信息
     * @param {string} [openid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public profileSearchTrackWeapp(openid?: string, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).profileSearchTrackWeapp(openid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 驿站二维码列表
     * @param {string} [openid] 
     * @param {number} [stationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public qrcodesSearchTrackWeapp(openid?: string, stationId?: number, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).qrcodesSearchTrackWeapp(openid, stationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 查询历史（首页输入框下拉，最多 10 条）
     * @param {string} [openid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public queryHistorySearchTrackWeapp(openid?: string, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).queryHistorySearchTrackWeapp(openid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 扫码进入（解析二维码ID）
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public scanSearchTrackWeapp(code?: string, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).scanSearchTrackWeapp(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 我的驿站列表
     * @param {string} [openid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public stationsSearchTrackWeapp(openid?: string, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).stationsSearchTrackWeapp(openid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 我的数据概览
     * @param {string} [openid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public summarySearchTrackWeapp(openid?: string, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).summarySearchTrackWeapp(openid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改绑定账号
     * @param {SystemGenerateObject65} systemGenerateObject65 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public updateAccountSearchTrackWeapp(systemGenerateObject65: SystemGenerateObject65, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).updateAccountSearchTrackWeapp(systemGenerateObject65, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改个人资料（头像 / 昵称）
     * @param {SystemGenerateObject60} systemGenerateObject60 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public updateProfileSearchTrackWeapp(systemGenerateObject60: SystemGenerateObject60, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).updateProfileSearchTrackWeapp(systemGenerateObject60, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 修改驿站
     * @param {SystemGenerateObject63} systemGenerateObject63 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public updateStationSearchTrackWeapp(systemGenerateObject63: SystemGenerateObject63, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).updateStationSearchTrackWeapp(systemGenerateObject63, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 微信 chooseAvatar / H5 文件选择器拿到的本地图片，落到 public/upload/avatar 下
     * @summary 上传头像
     * @param {File} file 
     * @param {string} [openid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchTrackWeappApi
     */
    public uploadAvatarSearchTrackWeapp(file: File, openid?: string, options?: AxiosRequestConfig) {
        return SearchTrackWeappApiFp(this.configuration).uploadAvatarSearchTrackWeapp(file, openid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 获取swagger.json
         * @summary swagger接口文档
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _55720000000000000000system: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/swagger.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * 获取swagger.json
         * @summary swagger接口文档
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _55720000000000000000system(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._55720000000000000000system(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * 获取swagger.json
         * @summary swagger接口文档
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _55720000000000000000system(options?: any): AxiosPromise<any> {
            return localVarFp._55720000000000000000system(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * 获取swagger.json
     * @summary swagger接口文档
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public _55720000000000000000system(options?: AxiosRequestConfig) {
        return SystemApiFp(this.configuration)._55720000000000000000system(options).then((request) => request(this.axios, this.basePath));
    }
}



